import React, { useState, useEffect } from 'react';
import SecureFileImg from '../SecureFileImg';
import { openInAppFilePreview } from '../../utils/filePreviewBus';
import { toProtectedFileUrl } from '../../utils/secureFile';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import axios from '../../api';
import { labelValidasi } from '../../utils/labelValidasi';
import {
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
  Stack,
  Paper,
  Typography,
  Chip,
  Divider,
  Grid,
  Box,
  LinearProgress,
  FormControl,
  Select,
  MenuItem,
  Button,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  IconButton,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  TextField,
  Alert,
  Snackbar,
  Fade,
  CircularProgress,
  InputLabel,
  Tooltip,
  Badge,
  Avatar,
  Skeleton,
  Card,
  CardContent,
  InputAdornment,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  useMediaQuery
} from '@mui/material';
import {
  TaskAlt,
  PhotoCamera,
  ReportProblem,
  Add,
  CheckCircle,
  PlayCircle,
  PendingActions,
  Delete,
  EditNote,
  ExpandMore,
  Receipt,
  Engineering,
  CloudUpload,
  HomeWork,
  Close,
  Save,
  Refresh,
  History,
  Comment,
  AttachFile,
  Download,
  Visibility,
  VisibilityOff,
  Warning,
  Info,
  Check,
  Clear,
  Person,
  LocationOn,
  CalendarToday,
  Payments,
  AttachMoney as Money,
  Build,
  Assessment,
  Timeline,
  DoneAll,
  Cancel,
  Help,
  Email,
  Phone,
  Print,
  Share,
  MoreVert,
  Search,
  NavigateBefore,
  NavigateNext,
  FilterList
} from '@mui/icons-material';
import { getBantuan, getMonitoringDetail, getRabByBantuan, getProgressKeuangan, getProgressFisik, initProgressFisikPembangunan, initProgressFisikRehabilitasi, getProgressAdministrasi, initProgressAdministrasi, updateProgressKeuangan, updateProgressFisikLangkah, updateProgressAdministrasi, upsertRab, updateStatusProses, updateLangkahFormData, verifikasiLangkah, getVerifikasiByBantuan } from '../API/bantuan';
import StepUploadForm from './StepUploadForm';
import { FilePreviewModal } from './FilePreview';
import { getBantuanLangkahByBantuan } from '../API/bantuanLangkah';
import MapsBantuan from './MapsBantuan';
import FotoGallery from './FotoGallery';
import {
  KECAMATAN,
  DESA_KELURAHAN,
  JENIS_BANTUAN,
  getDesaByKecamatan,
  isValidKecamatan,
  isValidDesa,
  getLokasiLabel
} from '../datarecap/constants';
import { mergeAdministrasiProgress, calcAdmOnlyPercent, getAdmFileUrl } from '../../utils/admProgress';
import { getTemplate, getDocumentLabels, getFotoLabels, getKeuanganSyncLabel } from '../../utils/stepTemplates';
import { isFisikManualRehab } from '../../utils/fisikProgress';

// Constants
const STATUS_PROSES = ['Belum Dimulai', 'Sedang Berlangsung', 'Menunggu Verifikasi', 'Selesai', 'Ditolak', 'Dibatalkan'];
const STATUS_LANGKAH = ['Belum Dimulai', 'Sedang Berlangsung', 'Menunggu Verifikasi', 'Selesai', 'Ditolak'];
const STATUS_PROGRESS = ['Belum Dimulai', 'Sedang Berlangsung', 'Menunggu Verifikasi', 'Selesai'];

const BASE_URL = process.env.REACT_APP_URL || 'http://localhost:5100';

const calcProgressPercent = (steps) => {
  if (!steps?.length) return { presentase: 0, langkahSelesai: 0, totalLangkah: 0 };
  const totalBobot = steps.reduce((s, l) => s + (Number(l.bobot) || 0), 0);
  if (totalBobot > 0) {
    const bobotSelesai = steps.filter(l => l.status === 'Selesai').reduce((s, l) => s + (Number(l.bobot) || 0), 0);
    return {
      presentase: Math.round((bobotSelesai / totalBobot) * 100),
      langkahSelesai: steps.filter(l => l.status === 'Selesai').length,
      totalLangkah: steps.length,
    };
  }
  const langkahSelesai = steps.filter(l => l.status === 'Selesai').length;
  return {
    presentase: Math.round((langkahSelesai / steps.length) * 100),
    langkahSelesai,
    totalLangkah: steps.length,
  };
};

const calcRabPercent = (rab, admSteps = []) => {
  // Kontribusi RAB penuh hanya jika ADM langkah 3 (Penyusunan RAB & Gambar) Selesai/tervalidasi.
  // File terupload tanpa validasi tidak menaikkan progres.
  const admRabDone = Array.isArray(admSteps) && admSteps.some(
    (s) => Number(s.urutan) === 3 && s.status === 'Selesai'
  );
  if (admRabDone) return { presentase: 100, langkahSelesai: 1, totalLangkah: 1 };
  return { presentase: 0, langkahSelesai: 0, totalLangkah: 1 };
};

const ProgressProsesCard = ({ label, icon, pct, color = 'primary' }) => (
  <Paper sx={{ p: 2, bgcolor: '#f8f9fa', height: '100%' }}>
    <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
      {icon}
      <Typography variant="body2" fontWeight={600}>{label}</Typography>
    </Stack>
    <Typography variant="h5" fontWeight={700} color={`${color}.main`}>{pct.presentase}%</Typography>
    <LinearProgress variant="determinate" value={pct.presentase} sx={{ height: 6, borderRadius: 3, mt: 1 }} color={color} />
    <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: 'block' }}>
      {pct.langkahSelesai}/{pct.totalLangkah} langkah selesai
    </Typography>
  </Paper>
);

// Helper untuk format tanggal
const formatDate = (date) => {
  if (!date) return '-';
  return new Date(date).toLocaleDateString('id-ID', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

// Format tanggal tanpa jam (untuk tanggal bantuan & tanggal lahir)
const formatDateOnly = (date) => {
  if (!date) return '-';
  return new Date(date).toLocaleDateString('id-ID', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });
};

const formatRp = (value) => {
  if (!value) return 'Rp 0';
  return new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'IDR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(value);
};

const statusColor = (status) => {
  const colors = {
    'Selesai': 'success',
    'Sedang Berlangsung': 'warning',
    'Menunggu Verifikasi': 'info',
    'Belum Dimulai': 'default',
    'Ditolak': 'error',
    'Dibatalkan': 'error'
  };
  return colors[status] || 'default';
};

const statusIcon = (status) => {
  const icons = {
    'Selesai': <CheckCircle fontSize="small" />,
    'Sedang Berlangsung': <PlayCircle fontSize="small" />,
    'Menunggu Verifikasi': <PendingActions fontSize="small" />,
    'Belum Dimulai': <Help fontSize="small" />,
    'Ditolak': <Cancel fontSize="small" />,
    'Dibatalkan': <Cancel fontSize="small" />
  };
  return icons[status] || <Help fontSize="small" />;
};

// Keterangan arti setiap status langkah
const STATUS_KETERANGAN = {
  'Belum Dimulai': 'Langkah belum diproses, belum ada dokumen/foto yang diupload.',
  'Sedang Berlangsung': 'Sebagian dokumen/foto sudah diupload, namun belum lengkap.',
  'Menunggu Verifikasi': 'Semua dokumen wajib sudah diupload dan menunggu divalidasi oleh Admin/Koordinator TFL. Belum dihitung sebagai langkah selesai.',
  'Selesai': 'Langkah sudah divalidasi dan dihitung dalam progres.',
  'Ditolak': 'Langkah ditolak saat validasi, perlu perbaikan dokumen/foto.',
  'Dibatalkan': 'Langkah dibatalkan.'
};

// Hitung daftar dokumen/foto yang masih belum lengkap pada suatu langkah
// jenisBantuan dipakai agar foto urutan 1 (Pembangunan vs Rehab) benar
// supplierNames dipakai untuk langkah keuangan Pembayaran Supplier (bukti TF per supplier)
const getMissingItems = (step, tipe, jenisBantuan = '', supplierNames = []) => {
  try {
    const template = getTemplate(tipe, Number(step.urutan), jenisBantuan);
    const parseArr = (val) => { if (!val) return []; try { return typeof val === 'string' ? JSON.parse(val) : val; } catch { return []; } };
    const dok = parseArr(step.dokumen);
    const foto = parseArr(step.foto);
    const missing = [];
    // Keuangan Pembayaran Supplier: bukti transfer per masing-masing supplier
    if (tipe === 'keuangan' && template?.perSupplierBukti) {
      const n = Math.max(1, supplierNames.length);
      for (let i = 0; i < n; i++) {
        if (!dok[i]) {
          const nama = supplierNames[i] ? ` (${supplierNames[i]})` : ` ${i + 1}`;
          missing.push(`Bukti Transfer ke Supplier${nama}`);
        }
      }
      return missing;
    }
    (template?.dokumenWajib || []).forEach((label, idx) => {
      if (!dok[idx]) missing.push(label);
    });
    if (!template?.fotoOptional) {
      (template?.fotoWajib || []).forEach((label, idx) => {
        if (!foto[idx]) {
          // Rehab manual: sertakan nama tahap manual
          if (template?.isManualRehab) {
            const tahapName = step?.tahap || '';
            const cleanLabel = /^foto\b/i.test(String(label)) ? String(label).replace(/^foto\s*/i, '') : label;
            missing.push(tahapName ? `Foto ${cleanLabel} - ${tahapName}` : `Foto ${cleanLabel}`);
            return;
          }
          // Label sudah lengkap ("Foto 0% ...") atau perlu prefix "Foto "
          const labelText = /^foto\b/i.test(String(label)) ? label : `Foto ${label}`;
          missing.push(labelText);
        }
      });
    }
    return missing;
  } catch {
    return [];
  }
};

const ProsesBantuan = ({ 
  open = false, 
  onClose = () => {},
  bantuanId: propBantuanId,
  selected: propSelected,
  onUpdate = () => {},
  userRole: propUserRole,
  inline = false,
  inlineBantuanId = null,
  admOnly = false,
  embedded = false,
  inlineBackPath = '/proses-bantuan',
}) => {
  const authRole = useSelector((s) => s.authAdmin?.user?.role);
  const userRole = propUserRole || authRole || '';
  const navigate = useNavigate();
  // ============================================================
  // STATE MANAGEMENT
  // ============================================================
  
  // Data utama
  const [selected, setSelected] = useState(propSelected || null);
  const [bantuanId, setBantuanId] = useState(propBantuanId || null);
  const [pemohon, setPemohon] = useState(null);
  const [loading, setLoading] = useState(false);
  const [refreshing, setRefreshing] = useState(false);
  
  // Tab management
  const [tab, setTab] = useState('langkah');
  
  // Data langkah
  const [langkah, setLangkah] = useState([]);
  const [langkahLoading, setLangkahLoading] = useState(false);
  
  // Data logs
  const [logs, setLogs] = useState([]);
  const [logsLoading, setLogsLoading] = useState(false);
  
  // Data keluhan
  const [keluhan, setKeluhan] = useState([]);
  const [keluhanLoading, setKeluhanLoading] = useState(false);
  
  // Data progress
  const [presentase, setPresentase] = useState(null);
  const [canAction, setCanAction] = useState(false);
  
  // RAB & Progress
  const [rabData, setRabData] = useState(null);
  const [progressAdministrasi, setProgressAdministrasi] = useState([]);
  const [progressKeuangan, setProgressKeuangan] = useState([]);
  const [progressFisik, setProgressFisik] = useState([]);
  const [presentasePerProses, setPresentasePerProses] = useState(null);
  const [admBantuan, setAdmBantuan] = useState(null);
  const [verifikasiMap, setVerifikasiMap] = useState({});
  const [preview, setPreview] = useState({ open: false, files: [], labels: [], fileBase: null, title: '' });

  // Page mode (table list) — disabled when inline
  const isPageMode = !open && !inline;
  const isInline = inline;
  const [tableRows, setTableRows] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [tablePage, setTablePage] = useState(1);
  const tableLimit = 10;
  const [tableTotalPages, setTableTotalPages] = useState(1);
  const [tableSearch, setTableSearch] = useState('');
  const [tableStatusFilter, setTableStatusFilter] = useState('');
  const [detailOpen, setDetailOpen] = useState(false);

  // ============================================================
  // FORM STATES
  // ============================================================
  
  // Edit progress
  const [editStep, setEditStep] = useState(null);
  const [editStatus, setEditStatus] = useState('');
  const [editFoto, setEditFoto] = useState(null);
  const [editDokumen, setEditDokumen] = useState(null);
  const [editCatatan, setEditCatatan] = useState('');
  const [editSaving, setEditSaving] = useState(false);
  
  // RAB
  const [rabKeterangan, setRabKeterangan] = useState('');
  const [rabFile, setRabFile] = useState(null);
  const [rabSaving, setRabSaving] = useState(false);
  const [rabFilePreviewUrl, setRabFilePreviewUrl] = useState(null); // ⬅️ baru
const [rabPreviewOpen, setRabPreviewOpen] = useState(false);
  // Add langkah
  const [newTahap, setNewTahap] = useState('');
  const [addLangkahOpen, setAddLangkahOpen] = useState(false);
  const [addLangkahLoading, setAddLangkahLoading] = useState(false);
  
  // Log
  const [logOpen, setLogOpen] = useState(false);
  const [logForm, setLogForm] = useState({
    keterangan: '',
    keluhan: '',
    fotoLaporanPenerimaanBantuan: null,
    fotoLaporanPembelianMaterial: null,
    fotoProsesDropMaterial: null,
    fotoProsesPengerjaan: null
  });
  const [logSaving, setLogSaving] = useState(false);
  
  // Keluhan
  const [keluhanOpen, setKeluhanOpen] = useState(false);
  const [keluhanText, setKeluhanText] = useState('');
  const [keluhanLangkahId, setKeluhanLangkahId] = useState('');
  const [keluhanLangkahList, setKeluhanLangkahList] = useState([]);
  const [loadingKeluhanLangkah, setLoadingKeluhanLangkah] = useState(false);
  const [keluhanSaving, setKeluhanSaving] = useState(false);
  
  // Status langkah
  const [statusLangkahOpen, setStatusLangkahOpen] = useState(false);
  const [statusLangkahSaving, setStatusLangkahSaving] = useState(false);
  const [statusLangkahForm, setStatusLangkahForm] = useState({
    langkahId: null,
    tahap: '',
    status: '',
    catatan: '',
    foto: null,
    preview: ''
  });
  const isMobile = useMediaQuery('(max-width:800px)');
  
  // Snackbar
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success'
  });
  useEffect(() => {
  return () => {
    if (rabFilePreviewUrl) URL.revokeObjectURL(rabFilePreviewUrl);
  };
}, [rabFilePreviewUrl]);
  // Dialog konfirmasi
  const [confirmDialog, setConfirmDialog] = useState({
    open: false,
    title: '',
    message: '',
    onConfirm: null
  });

  // ============================================================
  // EFFECTS
  // ============================================================
  
  useEffect(() => {
    if (propSelected) {
      setSelected(propSelected);
      setBantuanId(propSelected?.bantuan?.id || propSelected?.BantuanId || propSelected?.id);
      if (propSelected?.bantuan?.id || propSelected?.BantuanId || propSelected?.id) {
        fetchAllData(propSelected?.bantuan?.id || propSelected?.BantuanId || propSelected?.id);
      }
    }
  }, [propSelected]);

  useEffect(() => {
    if (propBantuanId && !propSelected) {
      setBantuanId(propBantuanId);
      fetchAllData(propBantuanId);
    }
  }, [propBantuanId]);

  useEffect(() => {
    if (inlineBantuanId) {
      setBantuanId(inlineBantuanId);
      setSelected({ id: inlineBantuanId });
      fetchAllData(inlineBantuanId);
    }
  }, [inlineBantuanId]);

  useEffect(() => {
    const role = String(userRole || '').trim().toLowerCase().replace(/[\s_-]+/g, '');
    setCanAction(['admin', 'tfl', 'koordinatortfl'].includes(role));
  }, [userRole]);

  const canVerify = ['admin', 'koordinatortfl'].includes(String(userRole || '').trim().toLowerCase().replace(/[\s_-]+/g, ''));

  // Page mode: fetch table list
  useEffect(() => {
    if (isPageMode) fetchTableList();
  }, [tablePage, tableStatusFilter, isPageMode]);

  const fetchTableList = async () => {
    setTableLoading(true);
    try {
      const res = await getBantuan({
        page: tablePage,
        limit: tableLimit,
        searchName: tableSearch,
        statusProses: tableStatusFilter
      });
      setTableRows(res.data?.data || []);
      setTableTotalPages(res.data?.totalPages ?? res.data?.pagination?.totalPages ?? 1);
    } catch (err) {
      console.error(err);
    } finally {
      setTableLoading(false);
    }
  };

  const handleViewDetail = (id) => {
    navigate(`/proses-bantuan/${id}`);
  };

  const handleCloseDetail = () => {
    setDetailOpen(false);
    setSelected(null);
    if (isPageMode) fetchTableList();
  };

  const handleTableSearch = () => {
    setTablePage(1);
    fetchTableList();
  }

  // ============================================================
  // DATA FETCHING FUNCTIONS
  // ============================================================
  
  const fetchAllData = async (id) => {
    if (!id) return;
    setLoading(true);
    try {
      const res = await getMonitoringDetail(id);
      const data = res.data;
      setSelected(data.bantuan || data);
      setPemohon(data.pemohonDetail || data.pemohon || data.bantuan?.pemohonDetail || data.bantuan?.pemohon || null);
      setLangkah(data.langkah || []);
      setLogs(data.logs || []);
      setKeluhan(data.keluhan || []);
      setRabData(data.rab || null);
      setProgressAdministrasi(data.progressAdministrasi || []);
      setProgressKeuangan(data.progressKeuangan || []);
      setProgressFisik(data.progressFisik || []);
      setPresentase(data.presentase || data.Presentase || null);
      setPresentasePerProses(data.presentasePerProses || null);
      setAdmBantuan(data.admBantuan || null);
      getVerifikasiByBantuan(id).then(r => {
        const map = {};
        (r.data?.data || []).forEach(v => { map[v.BantuanLangkahId] = v; });
        setVerifikasiMap(map);
      }).catch(() => {});

      const rabRes = await getRabByBantuan(id).catch(() => null);
      const rab = rabRes?.data?.data;
      if (rab) {
        setRabData(rab);
        const [pk, pf, pa] = await Promise.allSettled([
          getProgressKeuangan(rab.id).catch(() => ({ data: { data: [] } })),
          getProgressFisik(rab.id).catch(() => ({ data: { data: [] } })),
          getProgressAdministrasi(rab.id).catch(() => ({ data: { data: [] } })),
        ]);
        setProgressKeuangan(pk.value?.data?.data || []);
        setProgressFisik(pf.value?.data?.data || []);
        setProgressAdministrasi(pa.value?.data?.data || []);
        setPresentasePerProses({
          rab: calcRabPercent(rab, data.langkah || data.Langkah || []),
          administrasi: calcProgressPercent(pa.value?.data?.data || []),
          keuangan: calcProgressPercent(pk.value?.data?.data || []),
          fisik: calcProgressPercent(pf.value?.data?.data || []),
        });
      } else {
        setRabData(null);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      showSnackbar('Gagal memuat data', 'error');
    } finally {
      setLoading(false);
    }
  };

  const fetchKeluhanLangkahList = async (bantuanId) => {
    setLoadingKeluhanLangkah(true);
    try {
      const res = await getBantuanLangkahByBantuan(bantuanId);
      setKeluhanLangkahList(res.data || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoadingKeluhanLangkah(false);
    }
  };

  // ============================================================
  // HANDLER FUNCTIONS
  // ============================================================
  
  const showSnackbar = (message, severity = 'success') => {
    setSnackbar({ open: true, message, severity });
  };

  const handleCloseSnackbar = () => {
    setSnackbar(prev => ({ ...prev, open: false }));
  };

  const handleRefresh = async () => {
    if (!bantuanId) return;
    setRefreshing(true);
    await fetchAllData(bantuanId);
    setRefreshing(false);
    showSnackbar('Data berhasil di-refresh', 'success');
  };

  // Update status proses
  const handleUpdateStatusProses = async (id, status) => {
    try {
      await updateStatusProses(id, status);
      showSnackbar('Status proses berhasil diupdate', 'success');
      onUpdate?.();
      await fetchAllData(id);
    } catch (error) {
      console.error('Error update status proses:', error);
      showSnackbar('Gagal update status proses', 'error');
    }
  };

  // Update status langkah
  const handleStatusLangkahSelect = (langkahItem, status) => {
    setStatusLangkahForm({
      langkahId: langkahItem.id,
      tahap: langkahItem.tahap,
      status: status,
      catatan: '',
      foto: null,
      preview: ''
    });
    setStatusLangkahOpen(true);
  };

  const handleStatusLangkahFile = (file) => {
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setStatusLangkahForm(prev => ({
          ...prev,
          foto: file,
          preview: reader.result
        }));
      };
      reader.readAsDataURL(file);
    }
  };

  const confirmStatusLangkah = async () => {
    if (!statusLangkahForm.foto) {
      showSnackbar('Foto langkah wajib diupload', 'error');
      return;
    }

    setStatusLangkahSaving(true);
    try {
      await new Promise(resolve => setTimeout(resolve, 1000));
      setStatusLangkahOpen(false);
      showSnackbar('Status langkah berhasil diupdate', 'success');
      await fetchAllData(bantuanId);
      await fetchAllData(bantuanId);
    } catch (error) {
      console.error('Error update status langkah:', error);
      showSnackbar('Gagal update status langkah', 'error');
    } finally {
      setStatusLangkahSaving(false);
    }
  };

  // Delete langkah
  const handleDeleteLangkah = (id) => {
    setConfirmDialog({
      open: true,
      title: 'Hapus Tahap',
      message: 'Apakah Anda yakin ingin menghapus tahap ini?',
      onConfirm: async () => {
        try {
          await new Promise(resolve => setTimeout(resolve, 500));
          showSnackbar('Tahap berhasil dihapus', 'success');
          await fetchAllData(bantuanId);
        } catch (error) {
          console.error('Error delete langkah:', error);
          showSnackbar('Gagal hapus tahap', 'error');
        }
        setConfirmDialog({ open: false, title: '', message: '', onConfirm: null });
      }
    });
  };

  // Add langkah
  const handleAddLangkah = async () => {
    if (!newTahap.trim()) {
      showSnackbar('Nama tahap wajib diisi', 'error');
      return;
    }

    setAddLangkahLoading(true);
    try {
      await new Promise(resolve => setTimeout(resolve, 500));
      setAddLangkahOpen(false);
      setNewTahap('');
      showSnackbar('Tahap berhasil ditambahkan', 'success');
      await fetchAllData(bantuanId);
      await fetchAllData(bantuanId);
    } catch (error) {
      console.error('Error add langkah:', error);
      showSnackbar('Gagal tambah tahap', 'error');
    } finally {
      setAddLangkahLoading(false);
    }
  };

  // Log handlers
  const handleLogFile = (key, file) => {
    if (file) {
      setLogForm(prev => ({
        ...prev,
        [key]: file
      }));
    }
  };

  const handleAddLog = async () => {
    if (!logForm.keterangan.trim()) {
      showSnackbar('Keterangan wajib diisi', 'error');
      return;
    }

    setLogSaving(true);
    try {
      await new Promise(resolve => setTimeout(resolve, 1000));
      setLogOpen(false);
      setLogForm({
        keterangan: '',
        keluhan: '',
        fotoLaporanPenerimaanBantuan: null,
        fotoLaporanPembelianMaterial: null,
        fotoProsesDropMaterial: null,
        fotoProsesPengerjaan: null
      });
      showSnackbar('Log berhasil ditambahkan', 'success');
      await fetchAllData(bantuanId);
    } catch (error) {
      console.error('Error add log:', error);
      showSnackbar('Gagal tambah log', 'error');
    } finally {
      setLogSaving(false);
    }
  };

  // Keluhan handlers
  const handleAddKeluhan = async () => {
    if (!keluhanText.trim()) {
      showSnackbar('Isi keluhan wajib diisi', 'error');
      return;
    }

    if (!keluhanLangkahId) {
      showSnackbar('Pilih tahapan bantuan', 'error');
      return;
    }

    setKeluhanSaving(true);
    try {
      await new Promise(resolve => setTimeout(resolve, 1000));
      setKeluhanOpen(false);
      setKeluhanText('');
      setKeluhanLangkahId('');
      showSnackbar('Keluhan berhasil dikirim', 'success');
      await fetchAllData(bantuanId);
    } catch (error) {
      console.error('Error add keluhan:', error);
      showSnackbar('Gagal kirim keluhan', 'error');
    } finally {
      setKeluhanSaving(false);
    }
  };

  // Progress handlers
  const openEdit = (step, type) => {
    setEditStep({ id: step.id, type });
    setEditStatus(step.status);
    setEditCatatan(step.catatan || '');
    setEditFoto(null);
    setEditDokumen(null);
  };

  const handleUpdateProgress = async (stepId, type) => {
    setEditSaving(true);
    try {
      const formData = new FormData();
      formData.append('status', editStatus);
      if (editFoto) {
        if (type === 'keuangan') { formData.append('foto', editFoto); }
        else { Array.from(editFoto).forEach(f => formData.append('foto', f)); }
      }
      if (editDokumen) { Array.from(editDokumen).forEach(f => formData.append('dokumen', f)); }

      if (type === 'keuangan') await updateProgressKeuangan(stepId, formData);
      else if (type === 'fisik') await updateProgressFisikLangkah(stepId, formData);
      else if (type === 'administrasi') await updateLangkahFormData(stepId, formData);

      setEditStep(null);
      setEditStatus('');
      setEditFoto(null);
      setEditDokumen(null);
      showSnackbar('Progress berhasil diupdate', 'success');
      await fetchAllData(bantuanId);
    } catch (error) {
      console.error('Error update progress:', error);
      showSnackbar('Gagal update progress', 'error');
    } finally {
      setEditSaving(false);
    }
  };

  const handleAdminSave = async (stepId, formData) => {
    setEditSaving(true);
    try {
      await updateLangkahFormData(stepId, formData);
      setEditStep(null);
      showSnackbar('Berkas berhasil disimpan', 'success');
      await fetchAllData(bantuanId);
      scrollToStep(stepId);
    } catch (error) {
      console.error('Error admin save:', error);
      showSnackbar('Gagal menyimpan berkas', 'error');
    } finally {
      setEditSaving(false);
    }
  };

  const handleStepSave = async (stepId, type, formData) => {
    setEditSaving(true);
    try {
      if (type === 'keuangan') await updateProgressKeuangan(stepId, formData);
      else if (type === 'fisik') await updateProgressFisikLangkah(stepId, formData);
      else await updateLangkahFormData(stepId, formData);
      setEditStep(null);
      showSnackbar('Berkas berhasil disimpan', 'success');
      await fetchAllData(bantuanId);
      scrollToStep(stepId);
    } catch (error) {
      showSnackbar('Gagal menyimpan berkas', 'error');
    } finally {
      setEditSaving(false);
    }
  };

  // Init progress
  const handleInitAdministrasi = async () => {
    const initId = rabData?.id || bantuanId;
    if (!initId) { showSnackbar('Data bantuan belum siap', 'error'); return; }
    try {
      await initProgressAdministrasi(initId);
      showSnackbar('Progress administrasi berhasil diinisialisasi', 'success');
      await fetchAllData(bantuanId);
    } catch (error) {
      console.error('Error init administrasi:', error);
      showSnackbar('Gagal inisialisasi administrasi', 'error');
    }
  };

  const handleVerifikasi = async (langkahId, status) => {
    try {
      await verifikasiLangkah(langkahId, { status, catatan: '' });
showSnackbar(status === 'Diverifikasi' ? 'Langkah divalidasi' : 'Langkah ditolak', 'success');
    } catch (error) {
      console.error('Validasi error:', error);
      showSnackbar('Gagal validasi', 'error');
    }
  };

  const handleSetSelesai = async (stepId, type) => {
    try {
      if (type === 'administrasi') {
        await verifikasiLangkah(stepId, { status: 'Diverifikasi', catatan: '' });
        showSnackbar('Langkah berhasil divalidasi', 'success');
        await fetchAllData(bantuanId);
        return;
      }
      const formData = new FormData();
      formData.append('status', 'Selesai');
      if (type === 'keuangan') await updateProgressKeuangan(stepId, formData);
      else if (type === 'fisik') await updateProgressFisikLangkah(stepId, formData);
      else if (type === 'administrasi') await updateLangkahFormData(stepId, formData);
      showSnackbar('Status diubah ke Selesai', 'success');
      await fetchAllData(bantuanId);
    } catch (error) {
      showSnackbar('Gagal update status', 'error');
    }
  };

  const openPreview = (files, labels, fileBase, title, activeIndex = 0) => {
    const arr = Array.isArray(files) ? files.slice() : [files];
    // Normalize BA filenames: if filename contains BA_Signed_ or BA_Verifikasi_, use basename
    const norm = arr.map((f) => {
      try {
        const s = String(f || '');
        if (s.includes('BA_Signed_') || s.includes('BA_Verifikasi_')) {
          return s.split('/').pop();
        }
        return f;
      } catch { return f; }
    });
    setPreview({
      open: true,
      files: norm,
      labels: Array.isArray(labels) ? labels : [labels],
      fileBase: fileBase || null,
      title: title || 'Preview',
      activeIndex: Number.isInteger(activeIndex) ? activeIndex : 0,
    });
  };

  // Setelah simpan langkah, kembalikan scroll ke posisi langkah yang barusan diisi
  const scrollToStep = (stepId) => {
    if (!stepId) return;
    // Tunggu render selesai setelah fetchAllData
    setTimeout(() => {
      const el = document.getElementById(`step-item-${stepId}`);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 350);
  };

  const handleInitPembangunan = async () => {
    const initId = rabData?.id || bantuanId;
    if (!initId) { showSnackbar('Data bantuan belum siap', 'error'); return; }
    try {
      await initProgressFisikPembangunan(initId);
      showSnackbar('Progress pembangunan berhasil diinisialisasi', 'success');
      await fetchAllData(bantuanId);
    } catch (error) {
      console.error('Error init pembangunan:', error);
      showSnackbar('Gagal inisialisasi pembangunan', 'error');
    }
  };

  const handleInitRehabilitasi = () => {
    openRehabInit();
  };

  const [fisikAddOpen, setFisikAddOpen] = useState(false);
  const [fisikNewTahap, setFisikNewTahap] = useState('');
  const [fisikNewAnggaran, setFisikNewAnggaran] = useState('');
  const [fisikRenameId, setFisikRenameId] = useState(null);

  // Dialog inisialisasi rehabilitasi: user isi langkah + nilai anggaran sendiri
  const [rehabInitOpen, setRehabInitOpen] = useState(false);
  const [rehabItems, setRehabItems] = useState([]);
  const rehabDefaultItems = () => {
    const mat = Number(selected?.nominalMaterial) || Number(selected?.nominal) || 0;
    if (mat > 0) {
      return [
        { pekerjaan: 'Rehab Atap', nilai: Math.round(mat * 0.3) },
        { pekerjaan: 'Rehab Dinding', nilai: Math.round(mat * 0.3) },
        { pekerjaan: 'Rehab Lantai & Finishing', nilai: Math.round(mat * 0.4) },
      ];
    }
    return [{ pekerjaan: '', nilai: 0 }];
  };
  const openRehabInit = () => {
    setRehabItems(rehabDefaultItems());
    setRehabInitOpen(true);
  };
  const handleRehabItemChange = (idx, field, value) => {
    setRehabItems(p => p.map((it, i) => i === idx ? { ...it, [field]: field === 'nilai' ? Number(value) || 0 : value } : it));
  };
  const addRehabItem = () => setRehabItems(p => [...p, { pekerjaan: '', nilai: 0 }]);
  const removeRehabItem = (idx) => setRehabItems(p => p.filter((_, i) => i !== idx));
  const rehabTotal = rehabItems.reduce((s, it) => s + (Number(it.nilai) || 0), 0);

  const handleInitRehabilitasiSubmit = async () => {
    const valid = rehabItems.filter(it => it.pekerjaan.trim() && Number(it.nilai) > 0);
    if (valid.length === 0) { showSnackbar('Minimal 1 langkah rehab dengan nilai > 0', 'error'); return; }
    const rabIdForInit = rabData?.id || selected?.id || bantuanId;
    if (!rabIdForInit) { showSnackbar('Bantuan belum siap untuk inisialisasi rehabilitasi', 'error'); return; }
    try {
      await initProgressFisikRehabilitasi(rabIdForInit, { items: valid, totalHarga: rehabTotal });
      showSnackbar('Progress rehabilitasi berhasil diinisialisasi', 'success');
      setRehabInitOpen(false);
      await fetchAllData(bantuanId);
    } catch (error) {
      console.error('Error init rehabilitasi:', error);
      showSnackbar(error?.response?.data?.message || 'Gagal inisialisasi rehabilitasi', 'error');
    }
  };

  const handleAddFisikLangkah = async () => {
    if (!fisikNewTahap.trim()) { showSnackbar('Nama tahap wajib diisi', 'error'); return; }
    try {
      await axios.post(`${BASE_URL}/rab/rab/progress-fisik/${rabData.id}/rehabilitasi/item`, {
        tahap: fisikNewTahap.trim(), anggaran: Number(fisikNewAnggaran) || 0,
      });
      showSnackbar('Langkah fisik berhasil ditambahkan', 'success');
      setFisikAddOpen(false); setFisikNewTahap(''); setFisikNewAnggaran('');
      await fetchAllData(bantuanId);
    } catch (error) {
      console.error('Error add fisik langkah:', error);
      showSnackbar('Gagal tambah langkah fisik', 'error');
    }
  };

  const handleFisikRename = async (id, newTahap) => {
    setFisikRenameId(null);
    if (!newTahap.trim()) return;
    try {
      await axios.put(`${BASE_URL}/rab/rab/progress-fisik/${id}`, { tahap: newTahap.trim() });
      showSnackbar('Nama tahap diperbarui', 'success');
      await fetchAllData(bantuanId);
    } catch (error) {
      showSnackbar('Gagal ganti nama tahap', 'error');
    }
  };

  const handleDeleteFisikLangkah = async (id) => {
    if (!window.confirm('Hapus langkah fisik ini?')) return;
    try {
      await axios.delete(`${BASE_URL}/rab/rab/progress-fisik/${id}`);
      showSnackbar('Langkah fisik dihapus', 'success');
      await fetchAllData(bantuanId);
    } catch (error) {
      showSnackbar('Gagal hapus langkah fisik', 'error');
    }
  };

  // RAB handlers
  const handleCreateRab = async () => {
    if (!rabFile) {
      showSnackbar('File RAB wajib diupload', 'error');
      return;
    }

    setRabSaving(true);
    try {
      await upsertRab({ BantuanId: bantuanId, keterangan: rabKeterangan, status: 'draft' }, rabFile);
      showSnackbar('RAB berhasil dibuat', 'success');
      setRabKeterangan('');
      setRabFile(null);
      await fetchAllData(bantuanId);
    } catch (error) {
      console.error('Error create RAB:', error);
      showSnackbar('Gagal buat RAB', 'error');
    } finally {
      setRabSaving(false);
    }
  };

  // ============================================================
  // MAIN RENDER
  // ============================================================
  const pctRab = presentasePerProses?.rab ?? calcRabPercent(rabData, langkah);
  const mergedAdministrasi = mergeAdministrasiProgress(progressAdministrasi, admBantuan);
  const pctAdm = presentasePerProses?.administrasi
    ?? (progressAdministrasi.length > 0 ? calcProgressPercent(mergedAdministrasi) : calcAdmOnlyPercent(admBantuan));
  const pctKeu = presentasePerProses?.keuangan ?? calcProgressPercent(progressKeuangan);
  const pctFisik = presentasePerProses?.fisik ?? calcProgressPercent(progressFisik);
  const jenisBantuan = selected?.JenisBantuan || selected?.bantuan?.JenisBantuan || '';
  const sourceDetail = selected?.Questionnaire || selected?.Verifikasi || selected?.RegisterUsulan || {};
  const supplierCount = selected?.BantuanSuppliers?.length || selected?.SupplierBarang?.length || 1;
  const supplierNames = (selected?.BantuanSuppliers || []).map(bs => bs.SupplierBarang?.namaSupplier || `Supplier ${bs.SupplierBarangId || ''}`);

  // Gabungkan data pemohon + sumber (Verifikasi/Questionnaire) agar tampil lengkap
  const penerimaData = (() => {
    const base = pemohon || {};
    return {
      ...base,
      nama: base.nama || selected?.namaLengkap || sourceDetail.namaLengkapKK || sourceDetail.namaKepalaKeluarga || '-',
      nik: base.nik || base.nomorKTP || sourceDetail.nomorKTP || sourceDetail.nik || selected?.nomorKTP || '-',
      nomorKTP: base.nomorKTP || base.nik || sourceDetail.nomorKTP || sourceDetail.nik || selected?.nomorKTP || '-',
      nomorKK: base.nomorKK || sourceDetail.nomorKK || selected?.nomorKK || '-',
      alamat: base.alamat || selected?.alamatLengkap || sourceDetail.alamatRumah || sourceDetail.alamat || sourceDetail.alamatPemohon || '-',
      kecamatan: base.kecamatan || selected?.kecamatan || sourceDetail.kecamatan || '-',
      desaKelurahan: base.desaKelurahan || selected?.desaKelurahan || sourceDetail.desaKelurahan || '-',
      tanggallahir: base.tanggallahir || sourceDetail.tanggallahir || null,
      jenisKelamin: base.jenisKelamin || sourceDetail.jenisKelamin || null,
      pekerjaan: base.pekerjaan || sourceDetail.pekerjaan || null,
      penghasilan: base.penghasilan ?? base.tingkatPenghasilanKeluarga ?? sourceDetail.penghasilan ?? sourceDetail.tingkatPenghasilanKeluarga ?? null,
      pendidikanTerakhir: base.pendidikanTerakhir || sourceDetail.pendidikanTerakhir || null,
      statusKepemilikanRumah: base.statusKepemilikanRumah || sourceDetail.statusKepemilikanRumah || null,
      StatusKepemilikanTanah: base.StatusKepemilikanTanah || sourceDetail.StatusKepemilikanTanah || sourceDetail.statusKepemilikanTanah || null,
      statusKeluarga: base.statusKeluarga || sourceDetail.statusKeluarga || null,
      rumahTinggalSendiri: base.rumahTinggalSendiri || sourceDetail.rumahTinggalSendiri || null,
      usiaPernikahan: base.usiaPernikahan || sourceDetail.usiaPernikahan || null,
      jumlahPenghuni: base.jumlahPenghuni ?? base.jumlahPenghuniRumah ?? sourceDetail.jumlahPenghuni ?? sourceDetail.jumlahPenghuniRumah ?? null,
      kategori: base.kategori || sourceDetail.kategori || '-',
      score: base.score ?? sourceDetail.score ?? null,
      statusVerifikasi: base.statusVerifikasi || sourceDetail.statusVerifikasi || null,
      verifikasiBantuan: base.verifikasiBantuan || sourceDetail.verifikasiBantuan || null,
      catatan: base.catatan || sourceDetail.catatan || null,
      noWaPenerima: base.noWaPenerima || selected?.noWaPenerimaBantuan || '-',
      noRekening: base.noRekening || selected?.noRekening || '-',
      sumber: base.sumber || (selected?.VerifikasiId || selected?.Verifikasi ? 'Verifikasi' : selected?.QuestionnaireId || selected?.Questionnaire ? 'Questionnaire' : selected?.RegisterUsulanId ? 'Register' : selected?.sumberData || '-'),
    };
  })();

  const getStepDocumentLabels = (step, files) => getDocumentLabels('administrasi', step, files, jenisBantuan);

  const getStepFotoLabels = (type, step, files) => getFotoLabels(type, step, files, jenisBantuan);

  const getProgressDocumentLabels = (type, step, files) => {
    const template = getTemplate(type, Number(step.urutan), jenisBantuan);
    // Keuangan Pembayaran Supplier: label bukti transfer per supplier
    if (type === 'keuangan' && template?.perSupplierBukti) {
      return getDocumentLabels('keuangan', step, files, jenisBantuan, supplierNames);
    }
    return files.map((file, index) => {
      if (type === 'keuangan') {
        const syncLabel = getKeuanganSyncLabel(step, file, index);
        if (syncLabel) return syncLabel;
      }
      return template?.dokumenWajib?.[index] || file;
    });
  };

  const getFotoStepImageUrl = (foto, tahap) => {
    if (!foto) return '';
    try {
      const parsed = typeof foto === 'string' ? JSON.parse(foto) : foto;
      const arr = Array.isArray(parsed) ? parsed : [parsed];
      if (arr.length === 0) return '';
      const firstFile = arr[0];
      if (!firstFile) return '';
      // Use toProtectedFileUrl for already full URLs, else construct rab-progress path
      const filename = String(firstFile).split('/').pop();
      return toProtectedFileUrl(`${BASE_URL}/files/rab-progress/${filename}`);
    } catch {
      return '';
    }
  };

  const getDokumenStepUrl = (dokumen, index) => {
    if (!dokumen) return '';
    try {
      const parsed = typeof dokumen === 'string' ? JSON.parse(dokumen) : dokumen;
      const arr = Array.isArray(parsed) ? parsed : [parsed];
      if (!arr[index]) return '';
      const file = arr[index];
      if (!file) return '';
      const filename = String(file).split('/').pop();
      return toProtectedFileUrl(`${BASE_URL}/files/rab-progress/${filename}`);
    } catch {
      return '';
    }
  };

  const contentStyle = embedded || isMobile
    ? {} 
    : { marginLeft: "250px", marginRight: "20px" };

  return (
   
    <div className="table-responsive rounded border">
      <div className="main-content" style={contentStyle}>
    {isPageMode && !isInline && (
      <Box sx={{ p: { xs: 1, sm: 2 } }}>
        <Typography variant="h5" fontWeight={600} sx={{ mb: 2, fontSize: { xs: '1.1rem', sm: '1.5rem' } }}>
          <Engineering sx={{ mr: 1, verticalAlign: 'middle' }} />
          Proses Bantuan
        </Typography>
        <Card>
          <CardContent>
            <Stack direction="row" spacing={1} sx={{ mb: 2, flexWrap: 'wrap', gap: 1 }}>
              <TextField
                size="small"
                placeholder="Cari nama Penerima..."
                value={tableSearch}
                onChange={(e) => setTableSearch(e.target.value)}
                onKeyDown={(e) => { if (e.key === 'Enter') handleTableSearch(); }}
                InputProps={{
                  startAdornment: <InputAdornment position="start"><Search fontSize="small" /></InputAdornment>,
                  endAdornment: tableSearch && (
                    <InputAdornment position="end">
                      <IconButton size="small" onClick={() => { setTableSearch(''); setTablePage(1); }}><Clear fontSize="small" /></IconButton>
                    </InputAdornment>
                  )
                }}
                sx={{ minWidth: 220 }}
              />
              <FormControl size="small" sx={{ minWidth: 170 }}>
                <InputLabel>Status</InputLabel>
                <Select label="Status" value={tableStatusFilter} onChange={(e) => { setTableStatusFilter(e.target.value); setTablePage(1); }}>
                  <MenuItem value="">Semua</MenuItem>
                  {STATUS_PROSES.map((s) => <MenuItem key={s} value={s}>{s}</MenuItem>)}
                </Select>
              </FormControl>
            </Stack>

            <TableContainer component={Paper} variant="outlined">
              <Table size="small">
                <TableHead>
                  <TableRow sx={{ bgcolor: '#f5f7fa' }}>
                    <TableCell sx={{ fontWeight: 600, fontSize: { xs: 11, sm: 13 } }}>No.</TableCell>
                    <TableCell sx={{ fontWeight: 600, fontSize: { xs: 11, sm: 13 } }}>Penerima</TableCell>
                    <TableCell sx={{ fontWeight: 600, fontSize: { xs: 11, sm: 13 } }}>Kecamatan</TableCell>
                    <TableCell sx={{ fontWeight: 600, fontSize: { xs: 11, sm: 13 } }}>Jenis</TableCell>
                    <TableCell sx={{ fontWeight: 600, fontSize: { xs: 11, sm: 13 } }}>Progress</TableCell>
                    <TableCell sx={{ fontWeight: 600, fontSize: { xs: 11, sm: 13 } }}>Status</TableCell>
                    <TableCell sx={{ fontWeight: 600, fontSize: { xs: 11, sm: 13 } }}>Aksi</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {tableLoading ? (
                    <TableRow><TableCell colSpan={7} sx={{ textAlign: 'center', py: 4 }}><CircularProgress size={24} /></TableCell></TableRow>
                  ) : tableRows.length === 0 ? (
                    <TableRow><TableCell colSpan={7} sx={{ textAlign: 'center', py: 4, color: '#888' }}>Tidak ada data.</TableCell></TableRow>
                  ) : tableRows.map((row, i) => (
                    <TableRow key={row.id || row.bantuan?.id} sx={{ '&:hover': { bgcolor: '#fafafa' } }}>
                      <TableCell>{(tablePage - 1) * tableLimit + i + 1}</TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>{row.pemohon?.nama || row.bantuan?.pemohon?.nama || '-'}</TableCell>
                      <TableCell>{row.pemohon?.kecamatan || row.bantuan?.pemohon?.kecamatan || '-'}</TableCell>
                      <TableCell>{row.JenisBantuan || row.bantuan?.JenisBantuan || '-'}</TableCell>
                      <TableCell sx={{ minWidth: 120 }}>
                        <Typography variant="caption">{row.Presentase?.presentase ?? row.bantuan?.Presentase?.presentase ?? 0}%</Typography>
                        <LinearProgress variant="determinate" value={Number(row.Presentase?.presentase ?? row.bantuan?.Presentase?.presentase ?? 0)} sx={{ height: 4, borderRadius: 2 }} />
                      </TableCell>
                      <TableCell>
                        <Chip size="small" color={statusColor(row.ProsesBantuan?.statusProses || row.bantuan?.ProsesBantuan?.statusProses)} label={row.ProsesBantuan?.statusProses || row.bantuan?.ProsesBantuan?.statusProses || '-'} />
                      </TableCell>
                      <TableCell>
                        <Button size="small" variant="contained" onClick={() => navigate(`/proses-bantuan/${row.id || row.bantuan?.id}`)}>Proses</Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            {tableTotalPages > 1 && (
              <Stack direction="row" justifyContent="center" spacing={1} sx={{ mt: 2 }}>
                <Button size="small" startIcon={<NavigateBefore />} disabled={tablePage <= 1} onClick={() => setTablePage((p) => p - 1)}>Prev</Button>
                <Typography variant="body2" sx={{ display: 'flex', alignItems: 'center' }}>{tablePage} / {tableTotalPages}</Typography>
                <Button size="small" endIcon={<NavigateNext />} disabled={tablePage >= tableTotalPages} onClick={() => setTablePage((p) => p + 1)}>Next</Button>
              </Stack>
            )}
          </CardContent>
        </Card>
      </Box>
    )}
    {isInline && (
    <Box sx={{ minHeight: '100vh', bgcolor: '#f5f7fa', borderRadius: { xs: 0, sm: 2 }, overflow: 'hidden' }}>
      <Box sx={{ px: { xs: 1.5, sm: 3 }, py: { xs: 1.25, sm: 2 }, bgcolor: 'white', borderBottom: '1px solid #e0e0e0', position: 'sticky', top: 0, zIndex: 10 }}>
        <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1}>
          <Typography variant="h6" fontWeight={600} sx={{ fontSize: { xs: '0.95rem', sm: '1.25rem' }, lineHeight: 1.3, flex: 1, minWidth: 0 }}>
            {admOnly ? 'Kelengkapan Dokumen Administrasi' : 'Detail Proses Penerima Bantuan'} #{selected?.id || bantuanId}
          </Typography>
          <Stack direction="row" spacing={1} sx={{ flexShrink: 0 }}>
            <Tooltip title="Refresh Data">
              <Button
                size="small"
                onClick={handleRefresh}
                disabled={refreshing || loading}
              >
                <Refresh fontSize="small" />
              </Button>
            </Tooltip>
            <Button size="small" variant="outlined" onClick={() => navigate(inlineBackPath)} sx={{ whiteSpace: 'nowrap' }}>
              {admOnly ? 'Selesai' : 'Kembali'}
            </Button>
          </Stack>
        </Stack>
      </Box>

      <Box sx={{ p: 0 }}>
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}><CircularProgress /></Box>
        ) : !selected ? (
          <Box sx={{ p: 3 }}><Alert severity="warning">Data penerima bantuan tidak ditemukan. Silakan pilih data penerima  bantuan yang valid.</Alert></Box>
        ) : (
          <Box sx={{ p: { xs: 2, sm: 3 } }}>
            <Grid container spacing={2} sx={{ mb: 3 }}>
              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, bgcolor: '#f5f7fa' }}>
                  <Typography variant="caption" color="text.secondary">ID Penerima Bantuan</Typography>
                  <Typography variant="h6" fontWeight={600}>#{selected?.id || bantuanId}</Typography>
                   <Typography variant="caption" color="text.secondary">Nama Penerima Bantuan</Typography>
                    <Typography variant="h6" color="text.secondary">{penerimaData?.nama || selected?.namaLengkap || selected?.Questionnaire?.namaLengkapKK || selected?.Verifikasi?.namaKepalaKeluarga || selected?.RegisterUsulan?.namaKepalaKeluarga || '-'}</Typography>
                    <Typography variant="caption" color="text.secondary">Alamat Penerima Bantuan</Typography>
                    <Typography variant="h6" color="text.secondary">{penerimaData?.alamat || selected?.alamatLengkap || selected?.Questionnaire?.alamatRumah || selected?.Verifikasi?.alamat || selected?.RegisterUsulan?.alamatPemohon || '-'}</Typography>
                    <Typography variant="caption" color="text.secondary">Desa/Kelurahan Penerima Bantuan</Typography>
                    <Typography variant="h6" color="text.secondary">{penerimaData?.desaKelurahan || selected?.desaKelurahan || selected?.Questionnaire?.desaKelurahan || selected?.Verifikasi?.desaKelurahan || '-'}</Typography>
                    <Typography variant="caption" color="text.secondary">Kecamatan Penerima Bantuan</Typography>
                    <Typography variant="h6" color="text.secondary">{penerimaData?.kecamatan || selected?.kecamatan || selected?.Questionnaire?.kecamatan || selected?.Verifikasi?.kecamatan || '-'}</Typography>
                </Paper>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, bgcolor: '#f5f7fa' }}>
                  <Typography variant="caption" color="text.secondary">Status</Typography>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Chip size="medium" color={statusColor(selected?.ProsesBantuan?.statusProses || selected?.bantuan?.ProsesBantuan?.statusProses)}
                      label={selected?.ProsesBantuan?.statusProses || selected?.bantuan?.ProsesBantuan?.statusProses || '-'} />
                    <Typography variant="body2" color="text.secondary">{presentase?.presentase || 0}% selesai</Typography>
                  </Box>
                </Paper>
              </Grid>
            </Grid>

            <Box sx={{ mb: 3 }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                <Typography variant="body2" fontWeight={500}>Progress Pengerjaan</Typography>
                <Typography variant="body2" fontWeight={600}>{presentase?.presentase || 0}%</Typography>
              </Box>
              <LinearProgress variant="determinate" value={presentase?.presentase || 0}
                sx={{ height: 8, borderRadius: 4 }} color={presentase?.presentase >= 100 ? 'success' : 'primary'} />
              <Typography variant="caption" color="text.secondary">
                {presentase?.langkahSelesai || 0} dari {presentase?.totalLangkah || 0} langkah selesai
              </Typography>
            </Box>

            {!admOnly && (<>
            {/* Ringkasan Progress per Proses */}
            <Typography variant="subtitle2" fontWeight={600} sx={{ mb: 1.5 }}>
              Progress per Proses
            </Typography>
            <Grid container spacing={2} sx={{ mb: 3 }}>
              <Grid item xs={6} sm={3}>
                <ProgressProsesCard label="File RAB" icon={<Receipt fontSize="small" color="primary" />} pct={pctRab} />
              </Grid>
              <Grid item xs={6} sm={3}>
                <ProgressProsesCard label="Administrasi" icon={<Receipt fontSize="small" color="info" />} pct={pctAdm} color="info" />
              </Grid>
              <Grid item xs={6} sm={3}>
                <ProgressProsesCard label="Berkas Keuangan" icon={<Money fontSize="small" color="warning" />} pct={pctKeu} color="warning" />
              </Grid>
              <Grid item xs={6} sm={3}>
                <ProgressProsesCard label="Pekerjaan Fisik" icon={<Engineering fontSize="small" color="success" />} pct={pctFisik} color="success" />
              </Grid>
            </Grid>

            {/* Legenda arti status langkah */}
            <Alert severity="info" icon={false} sx={{ mb: 2, py: 1 }}>
              <Typography variant="caption" fontWeight={700} sx={{ display: 'block', mb: 0.5 }}>Keterangan Status Langkah:</Typography>
              {['Belum Dimulai', 'Sedang Berlangsung', 'Menunggu Verifikasi', 'Selesai'].map((s) => (
                <Typography key={s} variant="caption" color="text.secondary" sx={{ display: 'block', lineHeight: 1.6 }}>
                  <Chip size="small" label={labelValidasi(s)} color={statusColor(s)} sx={{ fontSize: 10, height: 18, mr: 0.75, verticalAlign: 'middle' }} />
                  {STATUS_KETERANGAN[s]}
                </Typography>
              ))}
            </Alert>

            {!canAction && (
              <Alert severity="info" sx={{ mb: 2 }}>
                Hanya Admin dan TFL yang dapat mengupload dan mengelola dokumen proses bantuan.
              </Alert>
            )}

            {/* Informasi Penerima */}
            <Accordion defaultExpanded>
              <AccordionSummary expandIcon={<ExpandMore />}>
                <Typography variant="subtitle1" fontWeight={600}><Person sx={{ mr: 1, verticalAlign: 'middle' }} />Informasi Penerima Bantuan</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <Typography variant="caption" color="text.secondary">Nama</Typography>
                <Typography variant="body1" fontWeight={500}>{penerimaData?.nama || '-'}</Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="caption" color="text.secondary">NIK</Typography>
                <Typography variant="body1">{penerimaData?.nik || penerimaData?.nomorKTP || '-'}</Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="caption" color="text.secondary">Nomor KK</Typography>
                <Typography variant="body1">{penerimaData?.nomorKK || '-'}</Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="caption" color="text.secondary">Sumber Data</Typography>
                <Typography variant="body1">{penerimaData?.sumber || '-'}</Typography>
              </Grid>
              {penerimaData?.tanggallahir && (
              <Grid item xs={12} sm={6}>
                <Typography variant="caption" color="text.secondary">Tanggal Lahir</Typography>
                <Typography variant="body1">{formatDateOnly(penerimaData.tanggallahir)}</Typography>
              </Grid>
              )}
              {penerimaData?.jenisKelamin && (
              <Grid item xs={12} sm={6}>
                <Typography variant="caption" color="text.secondary">Jenis Kelamin</Typography>
                <Typography variant="body1">{penerimaData.jenisKelamin}</Typography>
              </Grid>
              )}
              {penerimaData?.pekerjaan && (
              <Grid item xs={12} sm={6}>
                <Typography variant="caption" color="text.secondary">Pekerjaan</Typography>
                <Typography variant="body1">{penerimaData.pekerjaan}</Typography>
              </Grid>
              )}
              <Grid item xs={12} sm={6}>
                <Typography variant="caption" color="text.secondary">Penghasilan</Typography>
                <Typography variant="body1">
                  {penerimaData?.penghasilan != null && penerimaData.penghasilan !== ''
                    ? (typeof penerimaData.penghasilan === 'number' ? formatRp(penerimaData.penghasilan) : penerimaData.penghasilan)
                    : '-'}
                </Typography>
              </Grid>
              {penerimaData?.statusKeluarga && (
              <Grid item xs={12} sm={6}>
                <Typography variant="caption" color="text.secondary">Status Keluarga</Typography>
                <Typography variant="body1">{penerimaData.statusKeluarga}</Typography>
              </Grid>
              )}
              {penerimaData?.StatusKepemilikanTanah && (
              <Grid item xs={12} sm={6}>
                <Typography variant="caption" color="text.secondary">Kepemilikan Tanah</Typography>
                <Typography variant="body1">{penerimaData.StatusKepemilikanTanah}</Typography>
              </Grid>
              )}
              {penerimaData?.jumlahPenghuni != null && (
              <Grid item xs={12} sm={6}>
                <Typography variant="caption" color="text.secondary">Jumlah Penghuni</Typography>
                <Typography variant="body1">{penerimaData.jumlahPenghuni}</Typography>
              </Grid>
              )}
              {penerimaData?.kategori && penerimaData.kategori !== '-' && (
              <Grid item xs={12} sm={6}>
                <Typography variant="caption" color="text.secondary">Kategori / Skor</Typography>
                <Typography variant="body1">{penerimaData.kategori}{penerimaData.score != null ? ` (skor ${penerimaData.score})` : ''}</Typography>
              </Grid>
              )}
                  <Grid item xs={12} sm={6}>
                    <Typography variant="caption" color="text.secondary">Kecamatan</Typography>
                    <Typography variant="body1">{penerimaData?.kecamatan || '-'}</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="caption" color="text.secondary">Desa/Kelurahan</Typography>
                    <Typography variant="body1">{penerimaData?.desaKelurahan || '-'}</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="caption" color="text.secondary">Lokasi Lengkap</Typography>
                    <Typography variant="body1">{getLokasiLabel(penerimaData?.kecamatan, penerimaData?.desaKelurahan) || penerimaData?.alamat || '-'}</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="caption" color="text.secondary">No. WA</Typography>
                    <Typography variant="body1">{penerimaData?.noWaPenerima || pemohon?.noHp || '-'}</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="caption" color="text.secondary">No. Rekening</Typography>
                    <Typography variant="body1">{penerimaData?.noRekening || '-'}</Typography>
                  </Grid>
                  {penerimaData?.catatan && (
                  <Grid item xs={12}>
                    <Typography variant="caption" color="text.secondary">Catatan</Typography>
                    <Typography variant="body1">{penerimaData.catatan}</Typography>
                  </Grid>
                  )}
                </Grid>

                {/* Galeri foto dari sumber data (Questionnaire / Verifikasi) */}
                {(() => {
                  const q = selected?.Questionnaire;
                  const v = selected?.Verifikasi;
                  const fotos = [];
                  // Questionnaire: array fotos[]
                  if (q?.fotos && Array.isArray(q.fotos)) {
                    q.fotos.forEach((f, i) => {
                      if (f.foto_rumah) fotos.push({ label: `Foto Rumah ${i + 1}`, src: f.foto_rumah });
                    });
                  } else if (q?.Fotos && Array.isArray(q.Fotos)) {
                    q.Fotos.forEach((f, i) => {
                      if (f.foto_rumah) fotos.push({ label: `Foto Rumah ${i + 1}`, src: f.foto_rumah });
                    });
                  }
                  // Verifikasi: fotoRumahSaatIni, foto, fotoKK, fotoSuratKepemilikanTanah
                  if (v) {
                    if (v.fotoRumahSaatIni) fotos.push({ label: 'Foto Rumah Saat Ini', src: v.fotoRumahSaatIni });
                    if (v.foto) fotos.push({ label: 'Foto Rumah', src: v.foto });
                    if (v.fotoKK) fotos.push({ label: 'Foto KK', src: v.fotoKK });
                    if (v.fotoSuratKepemilikanTanah) fotos.push({ label: 'Surat Kepemilikan Tanah', src: v.fotoSuratKepemilikanTanah });
                  }
                  // Fallback dari pemohon (pemohonDetail)
                  if (fotos.length === 0 && pemohon) {
                    if (pemohon.fotoRumahSaatIni) fotos.push({ label: 'Foto Rumah Saat Ini', src: pemohon.fotoRumahSaatIni });
                    if (pemohon.foto) fotos.push({ label: 'Foto Rumah', src: pemohon.foto });
                    if (pemohon.fotoKK) fotos.push({ label: 'Foto KK', src: pemohon.fotoKK });
                    if (pemohon.fotoSuratKepemilikanTanah) fotos.push({ label: 'Surat Kepemilikan Tanah', src: pemohon.fotoSuratKepemilikanTanah });
                  }
                  if (fotos.length === 0) return null;
                  return (
                    <Box sx={{ mt: 2 }}>
                      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1 }}>
                        Foto / Dokumen Sumber ({fotos.length})
                      </Typography>
                      <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
                        {fotos.map((f, i) => (
                          <Box key={i} sx={{ textAlign: 'center', maxWidth: 100 }}>
                            <SecureFileImg
                              src={toProtectedFileUrl(f.src)}
                              alt={f.label}
                              enablePreview={false}
                              style={{ width: 88, height: 88, objectFit: 'cover', borderRadius: 6, border: '1px solid #ddd', cursor: 'pointer', display: 'block' }}
                              onClick={() => openInAppFilePreview({ url: toProtectedFileUrl(f.src), title: f.label })}
                            />
                            <Typography variant="caption" sx={{ display: 'block', mt: 0.25, fontSize: 10, lineHeight: 1.2 }}>
                              {f.label}
                            </Typography>
                          </Box>
                        ))}
                      </Stack>
                    </Box>
                  );
                })()}
              </AccordionDetails>
            </Accordion>

            {/* Informasi Bantuan */}
            <Accordion defaultExpanded>
              <AccordionSummary expandIcon={<ExpandMore />}>
                <Typography variant="subtitle1" fontWeight={600}><Payments sx={{ mr: 1, verticalAlign: 'middle' }} />Informasi Penerima Bantuan</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="caption" color="text.secondary">Jenis Bantuan</Typography>
                    <Typography variant="body1" fontWeight={500}>{selected?.JenisBantuan || selected?.bantuan?.JenisBantuan || '-'}</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="caption" color="text.secondary">Nominal</Typography>
                    <Typography variant="body1" fontWeight={600} color="primary.main">{formatRp(selected?.nominal || selected?.bantuan?.nominal)}</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="caption" color="text.secondary">Tanggal Bantuan</Typography>
                    <Typography variant="body1">{formatDateOnly(selected?.tanggalBantuan || selected?.bantuan?.tanggalBantuan)}</Typography>
                  </Grid>

                  {/* Rincian Anggaran: Material & Upah Tukang */}
                  <Grid item xs={12}>
                    <Paper variant="outlined" sx={{ p: 1.5, bgcolor: '#f8f9fa', borderRadius: 2 }}>
                      <Typography variant="caption" fontWeight={700} color="text.secondary" sx={{ display: 'block', mb: 1 }}>
                        Rincian Anggaran
                      </Typography>
                      <Grid container spacing={1.5}>
                        <Grid item xs={12} sm={4}>
                          <Box sx={{ p: 1.5, bgcolor: '#e3f2fd', borderRadius: 1.5 }}>
                            <Typography variant="caption" color="text.secondary">Anggaran Material</Typography>
                            <Typography variant="subtitle2" fontWeight={700} color="info.main">
                              {formatRp(selected?.nominalMaterial ?? selected?.bantuan?.nominalMaterial)}
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <Box sx={{ p: 1.5, bgcolor: '#fff3e0', borderRadius: 1.5 }}>
                            <Typography variant="caption" color="text.secondary">Upah Tukang</Typography>
                            <Typography variant="subtitle2" fontWeight={700} color="warning.main">
                              {formatRp(selected?.nominalUpahKerja ?? selected?.bantuan?.nominalUpahKerja)}
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <Box sx={{ p: 1.5, bgcolor: '#e8f5e9', borderRadius: 1.5 }}>
                            <Typography variant="caption" color="text.secondary">Total (Material + Upah)</Typography>
                            <Typography variant="subtitle2" fontWeight={700} color="success.main">
                              {formatRp(
                                (Number(selected?.nominalMaterial ?? selected?.bantuan?.nominalMaterial) || 0) +
                                (Number(selected?.nominalUpahKerja ?? selected?.bantuan?.nominalUpahKerja) || 0)
                              )}
                            </Typography>
                          </Box>
                        </Grid>
                      </Grid>
                    </Paper>
                  </Grid>
                  {/* <Grid item xs={12} sm={6}>
                    <Typography variant="caption" color="text.secondary">Status Proses</Typography>
                    {canAction ? (
                      <FormControl size="small" fullWidth>
                        <Select value={selected?.ProsesBantuan?.statusProses || selected?.bantuan?.ProsesBantuan?.statusProses || ''}
                          onChange={(e) => handleUpdateStatusProses(bantuanId, e.target.value)}>
                          {STATUS_PROSES.map(s => <MenuItem key={s} value={s}>{s}</MenuItem>)}
                        </Select>
                      </FormControl>
                    ) : (
                      <Chip size="small" color={statusColor(selected?.ProsesBantuan?.statusProses || selected?.bantuan?.ProsesBantuan?.statusProses)}
                        label={selected?.ProsesBantuan?.statusProses || selected?.bantuan?.ProsesBantuan?.statusProses || '-'} />
                    )}
                  </Grid> */}
                </Grid>
              </AccordionDetails>
            </Accordion>

            {/* RAB Accordion */}
            {/* <Accordion defaultExpanded={!!rabData}>
              <AccordionSummary expandIcon={<ExpandMore />}>
                <Typography variant="subtitle1" fontWeight={600}>
                  <Payments sx={{ mr: 1, verticalAlign: 'middle' }} />
                  RAB (Rencana Anggaran Biaya)
                </Typography>
                <Chip size="small" sx={{ ml: 1 }} label={`${pctRab.presentase}%`} color={pctRab.presentase >= 100 ? 'success' : 'default'} />
                {rabData && <Chip size="small" sx={{ ml: 0.5 }} color={rabData.status === 'disetujui' ? 'success' : 'default'} label={rabData.status || '-'} />}
              </AccordionSummary>
              <AccordionDetails>
                {rabData ? (
                  <Stack spacing={2}>
                    <Typography variant="body2"><strong>Keterangan:</strong> {rabData.keterangan || '-'}</Typography>
                    {rabData.fileRab && (
                      <Button size="small" variant="outlined" startIcon={<Visibility />}
                        onClick={() => openInAppFilePreview({ url: `${BASE_URL}/rab/file/${rabData.fileRab.replace('rab/', '')}` })}>Lihat Berkas</Button>
                    )}
                  </Stack>
                ) : canAction ? (
                  <Box>
                    <Alert severity="info" sx={{ mb: 2 }}>File ini terintegrasi dengan langkah ADM.</Alert>
                 <TextField label="Keterangan RAB" value={rabKeterangan} onChange={(e) => setRabKeterangan(e.target.value)} multiline rows={2} size="small" fullWidth />
<Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
  <Button component="label" variant="outlined" size="small" startIcon={<CloudUpload />}>
    {rabFile ? rabFile.name : 'Pilih File RAB (PDF)'}
    <input
      type="file"
      hidden
      accept=".pdf,application/pdf"
      onChange={(e) => {
        const file = e.target.files[0];
        if (rabFilePreviewUrl) URL.revokeObjectURL(rabFilePreviewUrl);
        setRabFile(file || null);
        setRabFilePreviewUrl(file ? URL.createObjectURL(file) : null);
      }}
    />
  </Button>
  {rabFile && (
    <Button size="small" variant="text" startIcon={<Visibility />} onClick={() => setRabPreviewOpen(true)}>
      Preview
    </Button>
  )}
</Stack>
                  </Box>
                ) : (
                  <Typography variant="body2" color="text.secondary">RAB belum dibuat.</Typography>
                )}
              </AccordionDetails>
            </Accordion> */}
            </>)}

            {/* Progress Administrasi */}
            {(rabData || admBantuan || (langkah && langkah.length > 0)) && (
              <Accordion defaultExpanded>
                <AccordionSummary expandIcon={<ExpandMore />} sx={{ '& .MuiAccordionSummary-content': { flexWrap: 'wrap', alignItems: 'center' } }}>
                  <Typography variant="subtitle1" fontWeight={600} sx={{ fontSize: { xs: '0.85rem', sm: '1rem' } }}>
                    <Receipt sx={{ mr: 1, verticalAlign: 'middle', fontSize: { xs: 18, sm: 24 } }} />
                    A. Progress Administrasi
                  </Typography>
                  <Chip size="small" sx={{ ml: 1 }} label={`${pctAdm.presentase}%`} color={pctAdm.presentase >= 100 ? 'success' : 'default'} />
                  {(mergedAdministrasi.length > 0 || (langkah && langkah.length > 0)) && (
                    <Chip size="small" sx={{ ml: 0.5 }} label={`${mergedAdministrasi.length > 0 ? mergedAdministrasi.filter(l => l.status === 'Selesai' || (l.dokumen || l.foto)).length : (langkah || []).filter(l => l.status === 'Selesai').length}/${mergedAdministrasi.length > 0 ? mergedAdministrasi.length : (langkah || []).length}`} variant="outlined" />
                  )}
                </AccordionSummary>
                <AccordionDetails>
                  <Alert severity="info" icon={false} sx={{ mb: 2, py: 1 }}>
                    <Typography variant="caption" fontWeight={700} sx={{ display: 'block', mb: 0.5 }}>Keterangan Status Langkah:</Typography>
                    {['Belum Dimulai', 'Sedang Berlangsung', 'Menunggu Verifikasi', 'Selesai'].map((s) => (
                      <Typography key={s} variant="caption" color="text.secondary" sx={{ display: 'block', lineHeight: 1.6 }}>
                        <Chip size="small" label={labelValidasi(s)} color={statusColor(s)} sx={{ fontSize: 10, height: 18, mr: 0.75, verticalAlign: 'middle' }} />
                        {STATUS_KETERANGAN[s]}
                      </Typography>
                    ))}
                  </Alert>
                  {(() => {
                  const displaySteps = mergedAdministrasi.length > 0 ? mergedAdministrasi
                    : (langkah && langkah.length > 0 ? langkah.map(l => ({ ...l })) : []);
                    if (displaySteps.length === 0) {
                      return (
                        <Stack spacing={1}>
                          <Typography variant="body2" color="text.secondary">Progress administrasi belum dibuat.</Typography>
                          {canAction && rabData && (
                            <Button size="small" variant="contained" color="primary" onClick={handleInitAdministrasi} startIcon={<CheckCircle />}>
                              Inisialisasi Progress Administrasi
                            </Button>
                          )}
                        </Stack>
                      );
                    }
                    return (
                      <Box sx={{ position: 'relative', pl: 2 }}>
                        {displaySteps.map((step, idx) => {
                          const fileBase = step.fileBase || null;
                          return (
                          <Box key={step.id} id={`step-item-${step.id}`} sx={{ position: 'relative', pb: 3 }}>
                            {idx < displaySteps.length - 1 && (
                              <Box sx={{ position: 'absolute', left: -5, top: 24, bottom: 0, width: 2, bgcolor: step.status === 'Selesai' ? 'success.main' : '#e0e0e0' }} />
                            )}
                            <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
                              <Box sx={{ minWidth: 28, height: 28, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center',
                                bgcolor: step.status === 'Selesai' ? 'success.main' : step.status === 'Sedang Berlangsung' ? 'warning.main' : '#e0e0e0',
                                color: step.status === 'Belum Dimulai' ? 'text.secondary' : 'white', fontSize: 12, fontWeight: 600, zIndex: 1 }}>
                                {step.status === 'Selesai' ? <Check fontSize="inherit" /> : idx + 1}
                              </Box>
                              <Box sx={{ flex: 1, minWidth: 0 }}>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: 0.5 }}>
                                  <Typography variant="body2" fontWeight={500} sx={{ flex: '1 1 60%', minWidth: 0, wordBreak: 'break-word' }}>{labelValidasi(step.tahap)}</Typography>
                                  <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center', flexWrap: 'wrap' }}>
                                    <Chip size="small" label={`${step.bobot || 0}%`} variant="outlined" sx={{ fontSize: 11 }} />
                                    <Chip size="small" color={statusColor(step.status)} label={labelValidasi(step.status)} />
                                    {verifikasiMap[step.id] && (
                                      <Chip size="small" color={verifikasiMap[step.id].status === 'Diverifikasi' ? 'success' : 'error'}
                                        label={verifikasiMap[step.id].status === 'Diverifikasi' ? '✓ Divalidasi' : '✗ Ditolak'}
                                        sx={{ fontSize: 10 }} />
                                    )}
                                  </Box>
                                </Box>
                                {/* Keterangan arti status langkah */}
                                <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.25, fontStyle: 'italic' }}>
                                  {STATUS_KETERANGAN[step.status] || ''}
                                </Typography>
                                {/* Daftar file yang belum lengkap */}
                                {step.status !== 'Selesai' && (() => {
                                  const missing = getMissingItems(step, 'administrasi', jenisBantuan);
                                  if (missing.length === 0) return null;
                                  return (
                                    <Alert severity="warning" icon={false} sx={{ mt: 0.5, py: 0.5, px: 1 }}>
                                      <Typography variant="caption" fontWeight={600} color="warning.dark" sx={{ display: 'block', mb: 0.25 }}>
                                        Belum lengkap ({missing.length}):
                                      </Typography>
                                      {missing.map((m, mi) => (
                                        <Typography key={mi} variant="caption" color="text.secondary" sx={{ display: 'block', lineHeight: 1.5 }}>
                                          • {m}
                                        </Typography>
                                      ))}
                                    </Alert>
                                  );
                                })()}
                                {canVerify && step.status === 'Menunggu Verifikasi' && (
                                  <Box sx={{ mt: 0.5, display: 'flex', gap: 0.5 }}>
                                    <Button size="small" variant="contained" color="success" sx={{ fontSize: 11, py: 0 }}
                                      onClick={() => handleVerifikasi(step.id, 'Diverifikasi')}>
                                      Validasi
                                    </Button>
                                    <Button size="small" variant="outlined" color="error" sx={{ fontSize: 11, py: 0 }}
                                      onClick={() => handleVerifikasi(step.id, 'Ditolak')}>
                                      Tolak
                                    </Button>
                                  </Box>
                                )}
                                {canVerify && step.status !== 'Selesai' && (() => {
                                  const hasFiles = (() => {
                                    try { const f = JSON.parse(step.foto || '[]'); const d = JSON.parse(step.dokumen || '[]'); return (Array.isArray(f) && f.length > 0) || (Array.isArray(d) && d.length > 0); }
                                    catch { return false; }
                                  })();
                                  if (hasFiles) return (
                                    <Button size="small" variant="contained" color="success" sx={{ fontSize: 11, py: 0, mt: 0.5 }}
                                      onClick={() => handleSetSelesai(step.id, 'administrasi')}>
                                      Validasi Selesai
                                    </Button>
                                  );
                                  return null;
                                })()}
                                {step.foto && (() => { try { const f = typeof step.foto === 'string' ? JSON.parse(step.foto) : step.foto; if (Array.isArray(f) && f.length > 0) { const fotoLabels = getStepFotoLabels('administrasi', step, f); return (<Stack direction="row" spacing={1} flexWrap="wrap" sx={{ mt: 0.5 }}>{f.map((x, i) => (<Box key={i} sx={{ textAlign: 'center', maxWidth: 72 }}><SecureFileImg src={getAdmFileUrl(x, fileBase, BASE_URL)} alt={fotoLabels[i]} enablePreview={false} style={{ width: 56, height: 56, objectFit: 'cover', borderRadius: 4, cursor: 'pointer' }} onClick={() => openPreview(f, fotoLabels, fileBase, step.tahap, i)} /><Typography variant="caption" sx={{ display: 'block', fontSize: 9, lineHeight: 1.2, color: 'text.secondary', mt: 0.25 }}>{fotoLabels[i]}</Typography></Box>))}</Stack>); } } catch(e){} return null; })()}
                                {step.dokumen && (() => { try { const d = typeof step.dokumen === 'string' ? JSON.parse(step.dokumen) : step.dokumen; if (Array.isArray(d) && d.length > 0) { const labels = getStepDocumentLabels(step, d); return (<Stack direction="row" spacing={0.5} flexWrap="wrap" sx={{ mt: 0.5 }}>{d.map((x, i) => <Chip key={i} size="small" label={labels[i]} variant="outlined" onClick={() => openPreview(d, labels, fileBase, step.tahap, i)} sx={{ cursor: 'pointer' }} />)}</Stack>); } } catch(e){} return null; })()}
                                {canAction && !step.readOnly && (
                                  <Box sx={{ mt: 1 }}>
                                    {editStep?.id === step.id && editStep?.type === 'administrasi' ? (
                                      <StepUploadForm step={step} type="administrasi" saving={editSaving} jenisBantuan={jenisBantuan} supplierCount={supplierCount} supplierNames={supplierNames} penerimaData={penerimaData}
                                        onSave={(formData) => handleAdminSave(step.id, formData)}
                                        onCancel={() => setEditStep(null)} />
                                    ) : (
                                      <Button size="small" variant="text" sx={{ mt: 0.5 }} onClick={() => setEditStep({ id: step.id, type: 'administrasi' })}>
                                        <PhotoCamera fontSize="small" sx={{ mr: 0.5 }} /> Kelola Upload
                                      </Button>
                                    )}
                                  </Box>
                                )}
                              </Box>
                            </Box>
                          </Box>
                          );
                        })}
                      </Box>
                    );
                  })()}
                </AccordionDetails>
              </Accordion>
            )}

            {!admOnly && (<>
            {/* Progress Keuangan */}
              <Accordion defaultExpanded>
                <AccordionSummary expandIcon={<ExpandMore />} sx={{ '& .MuiAccordionSummary-content': { flexWrap: 'wrap', alignItems: 'center' } }}>
                  <Typography variant="subtitle1" fontWeight={600} sx={{ fontSize: { xs: '0.85rem', sm: '1rem' } }}>
                    <Payments sx={{ mr: 1, verticalAlign: 'middle', fontSize: { xs: 18, sm: 24 } }} />
                    B. Progress Keuangan
                  </Typography>
                  <Chip size="small" sx={{ ml: 1 }} label={`${pctKeu.presentase}%`} color={pctKeu.presentase >= 100 ? 'success' : 'default'} />
                  {progressKeuangan.length > 0 && (
                    <Chip size="small" sx={{ ml: 0.5 }} label={`${progressKeuangan.filter(l => l.status === 'Selesai').length}/${progressKeuangan.length}`} variant="outlined" />
                  )}
                </AccordionSummary>
                <AccordionDetails>
                  <Alert severity="info" sx={{ mb: 2, py: 0.5 }}>
                    <Typography variant="caption">Step 1 (Dana Diterima) terintegrasi otomatis dari dokumen Administrasi (Transfer Dana). Droping = foto + nota. Pembayaran Supplier = bukti transfer. Upah = Form Pengambilan Upah.</Typography>
                  </Alert>
                  {progressKeuangan.length > 0 ? (
                    <Box sx={{ position: 'relative', pl: 2 }}>
                      {progressKeuangan.map((step, idx) => (
                        <Box key={step.id} id={`step-item-${step.id}`} sx={{ position: 'relative', pb: 3 }}>
                          {idx < progressKeuangan.length - 1 && (
                            <Box sx={{ position: 'absolute', left: -5, top: 24, bottom: 0, width: 2, bgcolor: step.status === 'Selesai' ? 'success.main' : '#e0e0e0' }} />
                          )}
                          <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
                            <Box sx={{ minWidth: 28, height: 28, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center',
                              bgcolor: step.status === 'Selesai' ? 'success.main' : step.status === 'Sedang Berlangsung' ? 'warning.main' : '#e0e0e0',
                              color: step.status === 'Belum Dimulai' ? 'text.secondary' : 'white', fontSize: 12, fontWeight: 600, zIndex: 1 }}>
                              {step.status === 'Selesai' ? <Check fontSize="inherit" /> : idx + 1}
                            </Box>
                            <Box sx={{ flex: 1, minWidth: 0 }}>
                              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: 0.5 }}>
                                <Typography variant="body2" fontWeight={500} sx={{ flex: '1 1 60%', minWidth: 0, wordBreak: 'break-word' }}>{labelValidasi(step.tahap)}</Typography>
                                <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center', flexWrap: 'wrap' }}>
                                  <Chip size="small" label={`${step.bobot}%`} variant="outlined" sx={{ fontSize: 11 }} />
                                  <Chip size="small" color={statusColor(step.status)} label={labelValidasi(step.status)} />
                                </Box>
                              </Box>
                              {/* Keterangan arti status + file belum lengkap (keuangan) */}
                              <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.25, fontStyle: 'italic' }}>
                                {STATUS_KETERANGAN[step.status] || ''}
                              </Typography>
                              {step.status !== 'Selesai' && (() => {
                                const missing = getMissingItems(step, 'keuangan', jenisBantuan, supplierNames);
                                if (missing.length === 0) return null;
                                return (
                                  <Alert severity="warning" icon={false} sx={{ mt: 0.5, py: 0.5, px: 1 }}>
                                    <Typography variant="caption" fontWeight={600} color="warning.dark" sx={{ display: 'block', mb: 0.25 }}>
                                      Belum lengkap ({missing.length}):
                                    </Typography>
                                    {missing.map((m, mi) => (
                                      <Typography key={mi} variant="caption" color="text.secondary" sx={{ display: 'block', lineHeight: 1.5 }}>• {m}</Typography>
                                    ))}
                                  </Alert>
                                );
                              })()}
                              {canVerify && step.status !== 'Selesai' && (step.foto || step.dokumen) && (
                                <Button size="small" variant="contained" color="success" sx={{ fontSize: 11, py: 0, mt: 0.5 }}
                                  onClick={() => handleSetSelesai(step.id, 'keuangan')}>
                                  Validasi Selesai
                                </Button>
                              )}
                              {step.foto && (() => {
                                try {
                                  const f = typeof step.foto === 'string' ? JSON.parse(step.foto) : step.foto;
                                  if (!Array.isArray(f) || f.length === 0) return null;
                                  const fotoLabels = getStepFotoLabels('keuangan', step, f);
                                  return (
                                    <Stack direction="row" spacing={1} flexWrap="wrap" sx={{ mt: 0.5 }}>
                                      {f.map((file, i) => {
                                        const filename = String(file).split('/').pop();
                                        const url = toProtectedFileUrl(`${BASE_URL}/files/rab-progress/${filename}`);
                                        return (
                                          <Box key={i} sx={{ textAlign: 'center', maxWidth: 72 }}>
                                            <SecureFileImg src={url} alt={fotoLabels[i] || `Foto Droping Material ${i + 1}`}
                                              style={{ width: 80, height: 80, objectFit: 'cover', borderRadius: 6, border: '1px solid #ddd', cursor: 'pointer' }}
                                              onClick={() => openPreview(f, fotoLabels, 'rab-progress', step.tahap, i)} />
                                            <Typography variant="caption" sx={{ display: 'block', fontSize: 9, lineHeight: 1.2, color: 'text.secondary', mt: 0.25 }}>
                                              {fotoLabels[i] || 'Foto Droping Material'}
                                            </Typography>
                                          </Box>
                                        );
                                      })}
                                    </Stack>
                                  );
                                } catch (e) {
                                  return null;
                                }
                              })()}
                              {step.dokumen && (() => { try { const d = typeof step.dokumen === 'string' ? JSON.parse(step.dokumen) : step.dokumen; if (Array.isArray(d) && d.length > 0) { const labels = getProgressDocumentLabels('keuangan', step, d); return (<Stack direction="row" spacing={0.5} flexWrap="wrap" sx={{ mt: 0.5 }}>{d.map((x, i) => <Chip key={i} size="small" label={labels[i]} variant="outlined" onClick={() => openPreview(d, labels, 'rab-progress', step.tahap, i)} sx={{ cursor: 'pointer' }} />)}</Stack>); } } catch(e){} return null; })()}
                              {canAction && (
                                <Box sx={{ mt: 1 }}>
                                  {editStep?.id === step.id && editStep?.type === 'keuangan' ? (
                                    <StepUploadForm step={step} type="keuangan" saving={editSaving} jenisBantuan={jenisBantuan} saveButtonColor="warning"
                                      supplierCount={supplierCount} supplierNames={supplierNames}
                                      onSave={(formData) => handleStepSave(step.id, 'keuangan', formData)}
                                      onCancel={() => setEditStep(null)} />
                                  ) : (
                                    <Button size="small" variant="text" sx={{ mt: 0.5 }} onClick={() => setEditStep({ id: step.id, type: 'keuangan' })}>
                                      <PhotoCamera fontSize="small" sx={{ mr: 0.5 }} /> Kelola Upload
                                    </Button>
                                  )}
                                </Box>
                              )}
                            </Box>
                          </Box>
                        </Box>
                      ))}
                    </Box>
                  ) : (
                    <Typography variant="body2" color="text.secondary">Progress keuangan otomatis dibuat saat bantuan dibuat.</Typography>
                  )}
                </AccordionDetails>
              </Accordion>
            </>)}

            {!admOnly && (<>
            {/* Progress Pekerjaan Fisik */}
              <Accordion defaultExpanded>
                <AccordionSummary expandIcon={<ExpandMore />} sx={{ '& .MuiAccordionSummary-content': { flexWrap: 'wrap', alignItems: 'center' } }}>
                  <Typography variant="subtitle1" fontWeight={600} sx={{ fontSize: { xs: '0.85rem', sm: '1rem' } }}>
                    <Engineering sx={{ mr: 1, verticalAlign: 'middle', fontSize: { xs: 18, sm: 24 } }} />
                    C. Progress Pekerjaan Fisik
                  </Typography>
                  <Chip size="small" sx={{ ml: 1 }} label={`${pctFisik.presentase}%`} color={pctFisik.presentase >= 100 ? 'success' : 'default'} />
                  {progressFisik.length > 0 && (
                    <Chip size="small" sx={{ ml: 0.5 }} label={`${progressFisik.filter(l => l.status === 'Selesai').length}/${progressFisik.length}`} variant="outlined" />
                  )}
                </AccordionSummary>
                <AccordionDetails>
                  {progressFisik.length > 0 ? (
                    <Box>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1, flexWrap: 'wrap' }}>
                        <Chip size="small" label={`Tipe: ${progressFisik[0]?.tipe || '-'}`} color="primary" />
                        {canAction && isFisikManualRehab(jenisBantuan) && (
                          <Button size="small" variant="outlined" color="primary" startIcon={<Add />} onClick={() => setFisikAddOpen(true)}>
                            Tambah Langkah
                          </Button>
                        )}
                      </Box>
                      <Box sx={{ position: 'relative', pl: 2 }}>
                        {progressFisik.map((step, idx) => (
                          <Box key={step.id} id={`step-item-${step.id}`} sx={{ position: 'relative', pb: 3 }}>
                            {idx < progressFisik.length - 1 && (
                              <Box sx={{ position: 'absolute', left: -5, top: 24, bottom: 0, width: 2, bgcolor: step.status === 'Selesai' ? 'success.main' : '#e0e0e0' }} />
                            )}
                            <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
                              <Box sx={{ minWidth: 28, height: 28, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center',
                                bgcolor: step.status === 'Selesai' ? 'success.main' : step.status === 'Sedang Berlangsung' ? 'warning.main' : '#e0e0e0',
                                color: step.status === 'Belum Dimulai' ? 'text.secondary' : 'white', fontSize: 12, fontWeight: 600, zIndex: 1 }}>
                                {step.status === 'Selesai' ? <Check fontSize="inherit" /> : idx + 1}
                              </Box>
                              <Box sx={{ flex: 1, minWidth: 0 }}>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: 0.5 }}>
                                  {fisikRenameId === step.id ? (
                                    <TextField size="small" defaultValue={step.tahap}
                                      onBlur={(e) => handleFisikRename(step.id, e.target.value)}
                                      onKeyDown={(e) => { if (e.key === 'Enter') handleFisikRename(step.id, e.target.value); if (e.key === 'Escape') setFisikRenameId(null); }}
                                      autoFocus sx={{ minWidth: 200 }} />
                                  ) : (
                                    <Typography variant="body2" fontWeight={500} onClick={() => canAction && setFisikRenameId(step.id)} sx={{ cursor: canAction ? 'pointer' : 'default', flex: '1 1 60%', minWidth: 0, wordBreak: 'break-word' }}>
                                      {step.tahap}
                                    </Typography>
                                  )}
                                  <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center', flexWrap: 'wrap' }}>
                                    <Chip size="small" label={`${step.bobot}%`} variant="outlined" sx={{ fontSize: 11 }} />
                                    <Chip size="small" color={statusColor(step.status)} label={labelValidasi(step.status)} />
                                    {userRole === 'admin' && (
                                      <Button size="small" onClick={() => handleDeleteFisikLangkah(step.id)}>
                                        <Delete fontSize="small" />
                                      </Button>
                                    )}
                                  </Box>
                                </Box>
                                {step.anggaran != null && (
                                  <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
                                    Anggaran: Rp {Number(step.anggaran || 0).toLocaleString('id-ID')}
                                  </Typography>
                                )}
                                {/* Keterangan arti status + file belum lengkap (fisik) */}
                                <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.25, fontStyle: 'italic' }}>
                                  {STATUS_KETERANGAN[step.status] || ''}
                                </Typography>
                                {step.status !== 'Selesai' && (() => {
                                  const missing = getMissingItems(step, 'fisik', jenisBantuan);
                                  if (missing.length === 0) return null;
                                  return (
                                    <Alert severity="warning" icon={false} sx={{ mt: 0.5, py: 0.5, px: 1 }}>
                                      <Typography variant="caption" fontWeight={600} color="warning.dark" sx={{ display: 'block', mb: 0.25 }}>
                                        Belum lengkap ({missing.length}):
                                      </Typography>
                                      {missing.map((m, mi) => (
                                        <Typography key={mi} variant="caption" color="text.secondary" sx={{ display: 'block', lineHeight: 1.5 }}>• {m}</Typography>
                                      ))}
                                    </Alert>
                                  );
                                })()}
                                {canVerify && step.status !== 'Selesai' && (step.foto || step.dokumen) && (
                                  <Button size="small" variant="contained" color="success" sx={{ fontSize: 11, py: 0, mt: 0.5 }}
                                    onClick={() => handleSetSelesai(step.id, 'fisik')}>
                                    Validasi Selesai
                                  </Button>
                                )}
                                 {step.foto && (() => { try { const f = typeof step.foto === 'string' ? JSON.parse(step.foto) : step.foto; if (Array.isArray(f) && f.length > 0) { const fotoLabels = getStepFotoLabels('fisik', step, f); return (<Stack direction="row" spacing={1} flexWrap="wrap" sx={{ mt: 0.5 }}>{f.map((x, i) => { const url = toProtectedFileUrl(`${BASE_URL}/files/rab-progress-fisik/${String(x).split('/').pop()}`); return (<Box key={i} sx={{ textAlign: 'center', maxWidth: 72 }}><SecureFileImg src={url} alt={fotoLabels[i]} enablePreview={false} style={{ width: 56, height: 56, objectFit: 'cover', borderRadius: 4, cursor: 'pointer' }} onClick={() => openPreview(f, fotoLabels, 'rab-progress-fisik', step.tahap)} /><Typography variant="caption" sx={{ display: 'block', fontSize: 9, lineHeight: 1.2, color: 'text.secondary', mt: 0.25 }}>{fotoLabels[i]}</Typography></Box>); })}</Stack>); } } catch(e){} return null; })()}
                                {canAction && (
                                  <Box sx={{ mt: 1 }}>
                                    {editStep?.id === step.id && editStep?.type === 'fisik' ? (
                                      <StepUploadForm step={step} type="fisik" saving={editSaving} jenisBantuan={jenisBantuan}
                                        nominalMaterial={Number(selected?.nominalMaterial) || Number(selected?.nominal) || 0}
                                        onSave={(formData) => handleStepSave(step.id, 'fisik', formData)}
                                        onCancel={() => setEditStep(null)} />
                                    ) : (
                                      <Button size="small" variant="text" sx={{ mt: 0.5 }} onClick={() => setEditStep({ id: step.id, type: 'fisik' })}>
                                        <PhotoCamera fontSize="small" sx={{ mr: 0.5 }} /> Kelola Upload
                                      </Button>
                                    )}
                                  </Box>
                                )}
                              </Box>
                            </Box>
                          </Box>
                        ))}
                      </Box>
                    </Box>
                  ) : (
                    <Stack spacing={1}>
                      <Typography variant="body2" color="text.secondary">Progress pekerjaan fisik belum dibuat.</Typography>
                      {canAction && (
                        <Stack direction="row" spacing={1}>
                          {!/rehab/i.test(jenisBantuan || '') && (
                            <Button size="small" variant="contained" color="success" startIcon={<HomeWork />} onClick={handleInitPembangunan}>
                              Inisialisasi Pembangunan
                            </Button>
                          )}
                          <Button size="small" variant="outlined" onClick={handleInitRehabilitasi}>
                            Inisialisasi Rehabilitasi
                          </Button>
                        </Stack>
                      )}
                    </Stack>
                  )}
                </AccordionDetails>
              </Accordion>
            </>)}
          </Box>
        )}
      </Box>

      <Box sx={{
        p: { xs: 1.5, sm: 2 },
        bgcolor: '#fafafa',
        borderTop: '1px solid #e0e0e0',
        display: 'flex',
        justifyContent: 'flex-end',
      }}>
        <Button onClick={() => navigate(inlineBackPath)} variant="contained">
          {admOnly ? 'Selesai Isi ADM' : 'Kembali ke Daftar Penerima Bantuan'}
        </Button>
      </Box>
    </Box>
    )}
      {/* ============================================================
          DIALOGS
          ============================================================ */}
      
      {/* Update Status Langkah Dialog */}
      {canAction && (
        <Dialog open={statusLangkahOpen} onClose={() => setStatusLangkahOpen(false)} maxWidth="sm" fullWidth>
          <DialogTitle>
            <Stack direction="row" spacing={1} alignItems="center">
              <PlayCircle color="warning" />
              <Typography variant="h6">Update Status Langkah</Typography>
            </Stack>
          </DialogTitle>
          <DialogContent>
            <Stack spacing={2} sx={{ mt: 1 }}>
              <Alert severity="info">
                <Typography variant="body2">
                  <strong>Tahap:</strong> {statusLangkahForm.tahap}
                </Typography>
                <Typography variant="body2">
                  <strong>Status baru:</strong> {statusLangkahForm.status}
                </Typography>
              </Alert>
              
              <TextField
                label="Catatan (opsional)"
                fullWidth
                multiline
                rows={2}
                value={statusLangkahForm.catatan}
                onChange={(e) => setStatusLangkahForm((p) => ({ ...p, catatan: e.target.value }))}
                placeholder="Tambahkan catatan untuk update ini..."
              />
              
              <Box>
                <Button 
                  variant="outlined" 
                  component="label" 
                  startIcon={<PhotoCamera />}
                  fullWidth
                  sx={{ py: 1.5 }}
                >
                  Upload Foto Langkah (wajib)
                  <input
                    type="file"
                    accept="image/*"
                    hidden
                    onChange={(e) => handleStatusLangkahFile(e.target.files?.[0])}
                  />
                </Button>
                {statusLangkahForm.preview && (
                  <Box sx={{ textAlign: 'center', mt: 1 }}>
                    <img
                      src={statusLangkahForm.preview}
                      alt="preview"
                      style={{ 
                        maxWidth: '100%', 
                        maxHeight: 220, 
                        borderRadius: 8, 
                        border: '1px solid #e0e0e0' 
                      }}
                    />
                  </Box>
                )}
              </Box>
            </Stack>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setStatusLangkahOpen(false)}>Batal</Button>
            <Button 
              variant="contained" 
              disabled={statusLangkahSaving || !statusLangkahForm.foto}
              onClick={confirmStatusLangkah}
              startIcon={statusLangkahSaving ? <CircularProgress size={16} /> : <Save />}
            >
              {statusLangkahSaving ? 'Menyimpan...' : 'Simpan'}
            </Button>
          </DialogActions>
        </Dialog>
      )}

      {/* Add Langkah Dialog */}
      {canAction && (
        <Dialog open={addLangkahOpen} onClose={() => setAddLangkahOpen(false)} maxWidth="xs" fullWidth>
          <DialogTitle>
            <Stack direction="row" spacing={1} alignItems="center">
              <Add color="primary" />
              <Typography variant="h6">Tambah Tahap</Typography>
            </Stack>
          </DialogTitle>
          <DialogContent>
            <TextField 
              autoFocus 
              fullWidth 
              margin="dense" 
              label="Nama Tahap" 
              value={newTahap}
              onChange={(e) => setNewTahap(e.target.value)}
              placeholder="Contoh: Validasi Dokumen"
              helperText="Masukkan nama tahap yang akan ditambahkan"
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setAddLangkahOpen(false)}>Batal</Button>
            <Button 
              variant="contained" 
              onClick={handleAddLangkah}
              disabled={addLangkahLoading || !newTahap.trim()}
              startIcon={addLangkahLoading ? <CircularProgress size={16} /> : <Add />}
            >
              {addLangkahLoading ? 'Menyimpan...' : 'Simpan'}
            </Button>
          </DialogActions>
        </Dialog>
      )}

      {/* Add Log Dialog */}
      {canAction && (
        <Dialog open={logOpen} onClose={() => setLogOpen(false)} maxWidth="sm" fullWidth>
          <DialogTitle>
            <Stack direction="row" spacing={1} alignItems="center">
              <History color="primary" />
              <Typography variant="h6">Tambah Log / Laporan</Typography>
            </Stack>
          </DialogTitle>
          <DialogContent>
            <Stack spacing={2} sx={{ mt: 1 }}>
              <TextField 
                label="Keterangan" 
                fullWidth 
                multiline 
                rows={2} 
                value={logForm.keterangan}
                onChange={(e) => setLogForm((p) => ({ ...p, keterangan: e.target.value }))}
                placeholder="Deskripsikan aktivitas yang dilakukan..."
                required
              />
              
              <TextField 
                label="Keluhan (opsional)" 
                fullWidth 
                multiline 
                rows={2} 
                value={logForm.keluhan}
                onChange={(e) => setLogForm((p) => ({ ...p, keluhan: e.target.value }))}
                placeholder="Jika ada kendala, tuliskan di sini..."
              />
              
              <Divider>Dokumentasi</Divider>
              
              {[
                { key: 'fotoLaporanPenerimaanBantuan', label: 'Foto Penerimaan Bantuan' },
                { key: 'fotoLaporanPembelianMaterial', label: 'Foto Pembelian Material' },
                { key: 'fotoProsesDropMaterial', label: 'Foto Drop Material' },
                { key: 'fotoProsesPengerjaan', label: 'Foto Pengerjaan' },
              ].map((f) => (
                <Button 
                  key={f.key} 
                  variant="outlined" 
                  component="label" 
                  startIcon={<PhotoCamera />} 
                  size="small"
                  fullWidth
                >
                  {logForm[f.key] ? `✓ ${f.label}` : f.label}
                  <input 
                    type="file" 
                    accept="image/*" 
                    hidden 
                    onChange={(e) => handleLogFile(f.key, e.target.files?.[0])} 
                  />
                </Button>
              ))}
            </Stack>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setLogOpen(false)}>Batal</Button>
            <Button 
              variant="contained" 
              onClick={handleAddLog}
              disabled={logSaving || !logForm.keterangan.trim()}
              startIcon={logSaving ? <CircularProgress size={16} /> : <Save />}
            >
              {logSaving ? 'Menyimpan...' : 'Kirim'}
            </Button>
          </DialogActions>
        </Dialog>
      )}

      {/* Add Keluhan Dialog */}
      {canAction && (
        <Dialog open={keluhanOpen} onClose={() => setKeluhanOpen(false)} maxWidth="sm" fullWidth>
          <DialogTitle>
            <Stack direction="row" spacing={1} alignItems="center">
              <ReportProblem color="error" />
              <Typography variant="h6">Laporkan Keluhan</Typography>
            </Stack>
          </DialogTitle>
          <DialogContent>
            <Stack spacing={2} sx={{ mt: 1 }}>
              <FormControl fullWidth size="small">
                <InputLabel>Tahapan Bantuan</InputLabel>
                <Select
                  value={keluhanLangkahId}
                  label="Tahapan Bantuan"
                  onChange={(e) => setKeluhanLangkahId(e.target.value)}
                  disabled={loadingKeluhanLangkah || keluhanLangkahList.length === 0}
                >
                  {keluhanLangkahList.length === 0 ? (
                    <MenuItem value="">Tidak ada tahapan tersedia</MenuItem>
                  ) : keluhanLangkahList.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      {item.tahap} ({item.status})
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              
              {loadingKeluhanLangkah && (
                <Stack alignItems="center">
                  <CircularProgress size={24} />
                </Stack>
              )}
              
              <TextField 
                autoFocus 
                fullWidth 
                label="Isi Keluhan" 
                multiline 
                rows={4}
                value={keluhanText} 
                onChange={(e) => setKeluhanText(e.target.value)}
                placeholder="Jelaskan secara detail keluhan yang Anda alami..."
                required
              />
            </Stack>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setKeluhanOpen(false)}>Batal</Button>
            <Button 
              variant="contained" 
              color="error"
              onClick={handleAddKeluhan}
              disabled={keluhanSaving || !keluhanText.trim() || !keluhanLangkahId}
              startIcon={keluhanSaving ? <CircularProgress size={16} /> : <ReportProblem />}
            >
              {keluhanSaving ? 'Mengirim...' : 'Kirim Keluhan'}
            </Button>
          </DialogActions>
        </Dialog>
      )}

      {/* Fisik Add Langkah Dialog */}
      <Dialog open={fisikAddOpen} onClose={() => setFisikAddOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Tambah Langkah Pekerjaan Fisik</DialogTitle>
        <DialogContent>
          <Stack spacing={2} sx={{ mt: 1 }}>
            <TextField label="Nama Pekerjaan" value={fisikNewTahap} onChange={(e) => setFisikNewTahap(e.target.value)}
              placeholder="Contoh: Pekerjaan Cat" size="small" fullWidth />
            <TextField label="Anggaran (Rp)" type="number" value={fisikNewAnggaran} onChange={(e) => setFisikNewAnggaran(e.target.value)}
              size="small" fullWidth placeholder="0" helperText="Persentase dihitung otomatis dari anggaran pekerjaan dibanding nominal material." />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setFisikAddOpen(false)}>Batal</Button>
          <Button variant="contained" color="primary" onClick={handleAddFisikLangkah}>Tambah</Button>
        </DialogActions>
      </Dialog>

      {/* Rehab Init Dialog */}
      <Dialog open={rehabInitOpen} onClose={() => setRehabInitOpen(false)} maxWidth="sx" fullWidth>
        <DialogTitle>
          <Stack direction="row" spacing={1} alignItems="center">
            <Build color="warning" />
            <Typography variant="h6">Inisialisasi Rehabilitasi — Isi Langkah Sendiri</Typography>
          </Stack>
        </DialogTitle>
        <DialogContent>
          <Alert severity="info" sx={{ my: 1 }}>
            <Typography variant="caption">
              Persentase tiap langkah dihitung otomatis dari nilai anggaran: (nilai / total anggaran) × 100%.
              Anggaran default diambil dari nominal material bantuan.
            </Typography>
          </Alert>
          <Stack spacing={1.5} sx={{ mt: 1 }}>
            {rehabItems.map((it, idx) => (
              <Paper key={idx} variant="outlined" sx={{ p: 1.5 }}>
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} alignItems="center">
                  <TextField label={`Langkah ${idx + 1}`} value={it.pekerjaan}
                    onChange={(e) => handleRehabItemChange(idx, 'pekerjaan', e.target.value)}
                    size="small" fullWidth placeholder="Nama pekerjaan rehab" />
                  <TextField label="Nilai (Rp)" type="number" value={it.nilai}
                    onChange={(e) => handleRehabItemChange(idx, 'nilai', e.target.value)}
                    size="small" sx={{ minWidth: 150 }} />
                  <Typography variant="caption" sx={{ minWidth: 60, textAlign: 'center', color: 'text.secondary' }}>
                    {rehabTotal > 0 ? `${((Number(it.nilai) || 0) / rehabTotal * 100).toFixed(1)}%` : '0%'}
                  </Typography>
                  <Button size="small" onClick={() => removeRehabItem(idx)} disabled={rehabItems.length === 1}>
                    <Delete fontSize="small" />
                  </Button>
                </Stack>
              </Paper>
            ))}
            <Button size="small" startIcon={<Add />} onClick={addRehabItem} sx={{ alignSelf: 'flex-start' }}>Tambah Langkah</Button>
            <Typography variant="body2" fontWeight={600}>
              Total Anggaran: {formatRp(rehabTotal)}
            </Typography>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setRehabInitOpen(false)}>Batal</Button>
          <Button variant="contained" color="warning" onClick={handleInitRehabilitasiSubmit}>
            Buat Progress Rehabilitasi
          </Button>
        </DialogActions>
      </Dialog>
{/* RAB File Preview Dialog (sebelum simpan) */}
<Dialog open={rabPreviewOpen} onClose={() => setRabPreviewOpen(false)} maxWidth="md" fullWidth>
  <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
    <Typography variant="subtitle1" noWrap sx={{ maxWidth: '80%' }}>{rabFile?.name}</Typography>
    <Button size="small" onClick={() => setRabPreviewOpen(false)}><Close fontSize="small" /></Button>
  </DialogTitle>
  <DialogContent>
    {rabFilePreviewUrl && (
      <Box sx={{ textAlign: 'center' }}>
        <object data={rabFilePreviewUrl} type="application/pdf" width="100%" height="500px" style={{ border: 'none' }}>
          <Typography variant="body2" sx={{ py: 4 }}>
            Browser tidak mendukung preview PDF inline.{' '}
            <Button size="small" onClick={() => openInAppFilePreview({ url: rabFilePreviewUrl, title: "Preview RAB" })}>Lihat Preview</Button>
          </Typography>
        </object>
      </Box>
    )}
  </DialogContent>
</Dialog>
      {/* Confirm Dialog */}
      <Dialog open={confirmDialog.open} onClose={() => setConfirmDialog({ open: false, title: '', message: '', onConfirm: null })}>
        <DialogTitle>{confirmDialog.title}</DialogTitle>
        <DialogContent>
          <Typography>{confirmDialog.message}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmDialog({ open: false, title: '', message: '', onConfirm: null })}>
            Batal
          </Button>
          <Button 
            variant="contained" 
            color="error"
            onClick={() => {
              if (confirmDialog.onConfirm) {
                confirmDialog.onConfirm();
              }
            }}
          >
            Hapus
          </Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar */}
      <Snackbar 
        open={snackbar.open} 
        autoHideDuration={4000}
        onClose={handleCloseSnackbar}
        TransitionComponent={Fade}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert 
          onClose={handleCloseSnackbar}
          severity={snackbar.severity} 
          variant="filled" 
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>

      <FilePreviewModal
        open={preview.open}
        onClose={() => setPreview(p => ({ ...p, open: false }))}
        files={preview.files}
        labels={preview.labels}
        fileBase={preview.fileBase}
        title={preview.title}
        activeIndex={preview.activeIndex}
      />
      </div>
      </div>
   
  );
};

export default ProsesBantuan;
